export default {
  'account.base.describe': '修改个人基本信息',
  'account.base.items.avatar.label': '头像',
  'account.base.items.avatar.size_limit': '图片大小不能超过5M',
  'account.base.items.avatar.upload': '上传头像',
  'account.base.items.avatar.upload_fail': '上传失败',
  'account.base.items.avatar.upload_success': '上传成功',
  'account.base.items.current_role': '当前角色',
  'account.base.items.realname': '真实姓名',
  'account.base.items.role': '角色类型',
  'account.base.items.username': '用户名',
  'account.base.title': '基本信息',
  'account.safe.describe': '修改个人安全设置',
  'account.safe.items.email.bind': '已绑定邮箱',
  'account.safe.items.email.label': '邮箱',
  'account.safe.items.email.unbind': '未绑定邮箱',
  'account.safe.items.password.actions': '修改密码',
  'account.safe.items.password.confirm_password': '确认密码',
  'account.safe.items.password.confirm_password_required': '请再次输入新密码',
  'account.safe.items.password.desc': '密码要求：8~128位，需包含字母、数字、特殊字符中至少两种',
  'account.safe.items.password.different_error': '两次输入密码不一致',
  'account.safe.items.password.label': '账号密码',
  'account.safe.items.password.modal_submit': '确认修改',
  'account.safe.items.password.modal_title': '修改密码',
  'account.safe.items.password.new_password': '新密码',
  'account.safe.items.password.new_password_required': '请输入新密码',
  'account.safe.items.password.old_password': '旧密码',
  'account.safe.items.password.old_password_required': '请输入旧密码',
  'account.safe.items.password.password_length': '密码长度范围需在6~18位之间',
  'account.safe.items.password.same_error': '新密码不能与旧密码相同',
  'account.safe.items.password.success': '密码修改成功',
  'account.safe.items.phone.bind': '已绑定手机号',
  'account.safe.items.phone.label': '手机号',
  'account.safe.items.phone.unbind': '未绑定手机号',
  'account.safe.title': '安全设置',
  'common.actions': '操作',
  'common.cancel': '取消',
  'common.close': '关闭',
  'common.closed': '关闭',
  'common.confirm': '确认',
  'common.create': '创建',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.view': '查看',
  'common.export': '导出',
  'common.high': '高',
  'common.low': '低',
  'common.medium': '中',
  'common.ng': 'NG',
  'common.no': '否',
  'common.ok': 'OK',
  'common.processing': '处理中',
  'common.solved': '已解决',
  'common.submit': '提交',
  'common.save': '保存',
  'common.update': '更新',
  'common.upload': '上传',
  'common.yes': '是',
  'components.form_generator.date_range.label': '日期范围',
  'components.form_generator.date_range.presets.month': '本月',
  'components.form_generator.date_range.presets.quarter': '本季度',
  'components.form_generator.date_range.presets.week': '本周',
  'components.form_generator.date_range.presets.year': '本年',
  'components.form_generator.period.day': '日',
  'components.form_generator.period.label': '周期单位',
  'components.form_generator.period.month': '月',
  'components.form_generator.period.week': '周',
  'components.form_generator.period.year': '年',
  'components.form_generator.search_pane.expand': '展开搜索',
  'components.form_generator.search_pane.reset': '重置',
  'components.form_generator.search_pane.search': '查询',
  'components.form_generator.week_start_day.label': '周统计开始时间',
  'components.form_generator.week_start_day.options.friday': '周五',
  'components.form_generator.week_start_day.options.monday': '周一',
  'components.form_generator.week_start_day.options.saturday': '周六',
  'components.form_generator.week_start_day.options.sunday': '周日',
  'components.form_generator.week_start_day.options.thursday': '周四',
  'components.form_generator.week_start_day.options.tuesday': '周二',
  'components.form_generator.week_start_day.options.wednesday': '周三',
  'components.trend.dimension.day': '日',
  'components.trend.dimension.month': '月',
  'components.trend.dimension.quarter': '季',
  'components.trend.dimension.week': '周',
  'components.trend.dimension.year': '年',
  'components.trend.range_limit': '开启范围限制',
  '  copyright': 'Copyright 2023 Makeblock质量中心',
  'header.account': '个人中心',
  'header.logout': '退出登录',
  'header.message.delete_read': '删除已读',
  'header.message.go_to_handle': '去处理',
  'header.message.mark_all_as_read': '全部已读',
  'header.message.mark_as_read': '已读',
  'header.message.no_message': '暂无消息',
  'header.message.title': '消息通知',
  'header.user_manual.title': '用户手册',
  'header.workplace': '工作台',
  'login.account.feishu_login': '飞书登录',
  'login.account.forget_password': '忘记密码',
  'login.account.login_button': '登录',
  'login.account.password': '密码',
  'login.account.place_holder': '请输入账号和密码',
  'login.account.title': '账号登录',
  'login.account.username': '账号',
  'login.bind_cloud_test.account_required': '请输入需要关联的账号',
  'login.bind_cloud_test.bind_success': '关联成功',
  'login.bind_cloud_test.confirm_bind': '确认关联',
  'login.bind_cloud_test.password': '密码',
  'login.bind_cloud_test.password_required': '请输入密码',
  'login.bind_cloud_test.role': '角色',
  'login.bind_cloud_test.role_required': '请选择角色',
  'login.bind_cloud_test.title': '关联的云测账号',
  'login.bind_feishu.is_bind_account': '是否关联已有账号',
  'login.bind_feishu.is_bind_account_option.false': '否',
  'login.bind_feishu.is_bind_account_option.true': '是',
  'login.feishu.open': '点击打开飞书认证',
  'login.feishu.title': '飞书登录',
  'login.feishu_redirect.binding_modal_alert': '当前飞书账号未注册云测系统，请选择角色注册',
  'login.feishu_redirect.binding_modal_title': '云测账号注册',
  'login.feishu_redirect.message.fail': '登录失败，请重试',
  'login.feishu_redirect.redirecting': '请稍等，跳转中',
  'login.forget.account': '返回账号登录',
  'login.forget.confirm_password': '确认密码',
  'login.forget.email': '邮箱',
  'login.forget.email_placeholder': '请输入邮箱',
  'login.forget.email_verify_code': '邮箱验证码',
  'login.forget.message.again': '重新',
  'login.forget.message.confirm_password_required': '请再次输入新密码',
  'login.forget.message.email_makeblock_only': '需为makeblock邮箱',
  'login.forget.message.email_required': '请输入邮箱',
  'login.forget.message.email_resend_message': '秒后可重发',
  'login.forget.message.email_verify_code_required': '请输入邮箱验证码',
  'login.forget.message.new_password_length': '密码长度范围需在6~18位之间',
  'login.forget.message.new_password_required': '请输入新密码',
  'login.forget.message.password_not_same': '两次输入密码不一致',
  'login.forget.message.password_reset_success': '密码重置成功，请重新登录',
  'login.forget.message.send_email': '发送邮箱验证码',
  'login.forget.new_password': '新密码',
  'login.forget.submit': '提交',
  'login.forget.title': '找回密码',
  'login.message.success.login': '登录成功',
  'login.register_cloud_test.button_text': '点击注册为新的云测账号使用',
  'login.register_cloud_test.register_success.content1': '注册成功，您的账号为:',
  'login.register_cloud_test.register_success.content2': ', 密码为:',
  'login.register_cloud_test.register_success.title': '注册成功',
  'login.second_title': '服务于 Makeblock 质量建设',
  'not_found.back': '返回首页',
  'not_found.desc': '未找到页面',
  'production.components.iqc_active_count.calendar.day_label.friday': '五',
  'production.components.iqc_active_count.calendar.day_label.monday': '一',
  'production.components.iqc_active_count.calendar.day_label.saturday': '六',
  'production.components.iqc_active_count.calendar.day_label.sunday': '日',
  'production.components.iqc_active_count.calendar.day_label.thursday': '四',
  'production.components.iqc_active_count.calendar.day_label.tuesday': '二',
  'production.components.iqc_active_count.calendar.day_label.wednesday': '三',
  'production.components.iqc_active_count.calendar.month_label.april': '四月',
  'production.components.iqc_active_count.calendar.month_label.august': '八月',
  'production.components.iqc_active_count.calendar.month_label.december': '十二月',
  'production.components.iqc_active_count.calendar.month_label.february': '二月',
  'production.components.iqc_active_count.calendar.month_label.january': '一月',
  'production.components.iqc_active_count.calendar.month_label.july': '七月',
  'production.components.iqc_active_count.calendar.month_label.june': '六月',
  'production.components.iqc_active_count.calendar.month_label.march': '三月',
  'production.components.iqc_active_count.calendar.month_label.may': '五月',
  'production.components.iqc_active_count.calendar.month_label.november': '十一月',
  'production.components.iqc_active_count.calendar.month_label.october': '十月',
  'production.components.iqc_active_count.calendar.month_label.september': '九月',
  'production.components.iqc_active_count.dimension.bill_cnt': '每天检验批量',
  'production.components.iqc_active_count.dimension.bill_per_user': '平均检验批量（检验批量/人数）',
  'production.components.iqc_active_count.dimension.inspector_cnt': '每天活跃人数',
  'production.components.iqc_active_count.dimension.material_cnt': '每天检验物料量',
  'production.components.iqc_active_count.dimension.material_per_user': '平均检验物料量（检验物料量/人数）',
  'production.components.iqc_active_count.tip': '来料活动图统计近一年内，每天的来料检验活动数据。',
  'production.components.iqc_active_count.title': '来料检验活动图',
  'production.components.iqc_class_trend.legend_data.electronic': '电子',
  'production.components.iqc_class_trend.legend_data.optical': '光学',
  'production.components.iqc_class_trend.legend_data.other': '其他',
  'production.components.iqc_class_trend.legend_data.structure': '结构',
  'production.components.iqc_class_trend.title': '批次合格率-物料分类',
  'production.components.iqc_class_trend.tooltip_formatter.bill_cnt': '总批次(IQC)',
  'production.components.iqc_class_trend.tooltip_formatter.bill_ng_cnt': '批次不合格数',
  'production.components.iqc_class_trend.tooltip_formatter.bill_ok_rate': '批次合格率',
  'production.components.iqc_class_trend.tooltip_formatter.inspection_time': '检验时间',
  'production.components.iqc_class_trend.tooltip_formatter.material_class': '物料分类',
  'production.components.iqc_class_trend.tooltip_formatter.material_ng_cnt': '物料不合格数',
  'production.components.iqc_class_trend.tooltip_formatter.material_ok_rate': '物料合格率',
  'production.components.iqc_class_trend.y_axis.bill_ok_rate': '批次合格率',
  'production.components.iqc_class_trend.y_axis.inspection_cnt': '检验数量',
  'production.components.material_inspect_bill_base.assign_button': '分配',
  'production.components.material_inspect_bill_base.audit.button': '审核',
  'production.components.material_inspect_bill_base.audit.success': '{billNo} 审核成功',
  'production.components.material_inspect_bill_base.cancel.button': '作废',
  'production.components.material_inspect_bill_base.cancel.confirm': '确定作废 {billNo} 吗？作废后将无法恢复',
  'production.components.material_inspect_bill_base.cancel.success': '{billNo} 作废成功',
  'production.components.material_inspect_bill_base.cancel.title': '作废',
  'production.components.material_inspect_bill_base.columns.accept_cnt': '允收数',
  'production.components.material_inspect_bill_base.columns.assign_at': '分配日期',
  'production.components.material_inspect_bill_base.columns.assigner_id': '单据分配',
  'production.components.material_inspect_bill_base.columns.attachment': '检验附件',
  'production.components.material_inspect_bill_base.columns.bill_no': '来料单号',
  'production.components.material_inspect_bill_base.columns.bill_status': '检验状态',
  'production.components.material_inspect_bill_base.columns.cancel_status': '是否作废',
  'production.components.material_inspect_bill_base.columns.create_date': '创建日期',
  'production.components.material_inspect_bill_base.columns.expect_finish_at': '加急截止日期',
  'production.components.material_inspect_bill_base.columns.inspect_cnt': '检验数量',
  'production.components.material_inspect_bill_base.columns.inspect_date': '单据日期',
  'production.components.material_inspect_bill_base.columns.inspect_result': '检验结果',
  'production.components.material_inspect_bill_base.columns.inspector_id': '质检员',
  'production.components.material_inspect_bill_base.columns.is_key': '是否关键物料',
  'production.components.material_inspect_bill_base.columns.is_rush_order': '是否加急',
  'production.components.material_inspect_bill_base.columns.urgent_status': '紧急状态',
  'production.components.material_inspect_bill_base.columns.is_special_purchase': '是否特采',
  'production.components.material_inspect_bill_base.columns.issue.create_button': '创建问题',
  'production.components.material_inspect_bill_base.columns.issue.title': '问题单',
  'production.components.material_inspect_bill_base.columns.k3_bill_status': '单据状态',
  'production.components.material_inspect_bill_base.columns.material_name': '物料名称',
  'production.components.material_inspect_bill_base.columns.material_number': '物料编号',
  'production.components.material_inspect_bill_base.columns.material_phase': '物料阶段',
  'production.components.material_inspect_bill_base.columns.composite_code': '合成编码',
  'production.components.material_inspect_bill_base.columns.product_category': '产品类别',
  'production.components.material_inspect_bill_base.columns.project_code': '项目编码',
  'production.components.material_inspect_bill_base.columns.qc_finish_at': '质检完成时间',
  'production.components.material_inspect_bill_base.columns.qc_start_at': '质检开始时间',
  'production.components.material_inspect_bill_base.columns.qualified_cnt': '合格数',
  'production.components.material_inspect_bill_base.columns.receive_at': '收料日期',
  'production.components.material_inspect_bill_base.columns.receive_bill_no': '收料单号',
  'production.components.material_inspect_bill_base.columns.receive_bill_type': '单据类型',
  'production.components.material_inspect_bill_base.columns.receiver_id': '收料下推',
  'production.components.material_inspect_bill_base.columns.reject_cnt': '拒收数',
  'production.components.material_inspect_bill_base.columns.remark': '备注',
  'production.components.material_inspect_bill_base.columns.rush_order_tag': '急',
  'production.components.material_inspect_bill_base.columns.sample_cnt': '样本数',
  'production.components.material_inspect_bill_base.columns.sample_damage_cnt': '样本损害数',
  'production.components.material_inspect_bill_base.columns.sample_seat': '样品位置',
  'production.components.material_inspect_bill_base.columns.sample_unqualified_cnt': '样本不合格数',
  'production.components.material_inspect_bill_base.columns.specification': '规格型号',
  'production.components.material_inspect_bill_base.columns.area_stock_name': '仓库',
  'production.components.material_inspect_bill_base.columns.stock_name': '库区',
  'production.components.material_inspect_bill_base.columns.supplier': '供应商',
  'production.components.material_inspect_bill_base.columns.unqualified_cnt': '不合格数',
  'production.components.material_inspect_bill_base.create_assign_modal.alert_message':
    '存在物料未绑定“检验规范”或“抽样方案”，请先联系相关 SQE 进行绑定',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.assign_success_message': '分配成功',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.bill_no': '来料单号',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.inspect_spec_name.title':
    '通用物料检验规范',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.inspect_spec_name.tooltip':
    '存在最新的版本: {lastSpecVersion}',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.material_name': '物料名称',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.material_number': '物料编号',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.no_inspector_message': '请选择检验员',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.no_spec_message':
    '存在物料未绑定检验规范或抽样方案',
  'production.components.material_inspect_bill_base.create_assign_modal.columns.sample_scheme_name': '物料抽样方案',
  'production.components.material_inspect_bill_base.create_assign_modal.inspector_id.help': '检验绑定规范是否正确',
  'production.components.material_inspect_bill_base.create_assign_modal.inspector_id.label': '检验员(IQC)',
  'production.components.material_inspect_bill_base.create_assign_modal.inspector_name': '检验员(IQC)',
  'production.components.material_inspect_bill_base.create_assign_modal.title': '{count} 个单据分配',
  'production.components.material_inspect_bill_base.export.button': '导出',
  'production.components.material_inspect_bill_base.export.filename': '来料检验单-{date}.xlsx',
  'production.components.material_inspect_bill_base.export.success': '{filename} 导出成功, 请在下载文件中查看',
  'production.components.material_inspect_bill_base.goto_inspect_button': '前往检验',
  'production.components.material_inspect_bill_base.re_audit_button': '重新审核',
  'production.components.material_inspect_bill_base.start_inspect_button': '开始检验',
  'production.components.material_inspect_bill_base.title': '来料检验单',
  'production.components.material_inspect_bill_base.un_audit.button': '反审核',
  'production.components.material_inspect_bill_base.un_audit.confirm': '确定反审核 {billNo} 吗？',
  'production.components.material_inspect_bill_base.un_audit.success': '{billNo} 反审核成功',
  'production.components.material_inspect_bill_base.un_audit.title': '反审核',
  'production.components.material_inspect_bill_base.view_button': '查看',
  'production.components.material_issue_card_trend.incoming_name': '来料问题库',
  'production.components.material_issue_card_trend.procedure_name': '制程问题库',
  'production.components.material_issue_class_card_list.material_issue_class_type_pie.tip': '来料不良数量-类型分类',
  'production.components.material_issue_class_card_list.material_issue_class_type_pie.title': '来料不良数量-类型分类',
  'production.components.material_issue_class_card_list.material_issue_count_card.tip': '来料不良次数-类型分类',
  'production.components.material_issue_class_card_list.material_issue_count_card.title': '来料不良次数-类型分类',
  'production.components.material_issue_class_card_list.series.name': '不良类型',
  'production.components.material_issue_process_card.footer.severity_cnt': '严重',
  'production.components.material_issue_process_card.footer.severity_rate': '严重占比',
  'production.components.material_issue_process_card.tip':
    '统计物料未解问题的趋势，请多关注严重问题，不能及时解决严重问题，会导致事故的发生。严重占比=严重数/未解决数。',
  'production.components.material_issue_process_card.title': '未解决不合格问题',
  'production.components.material_issue_total_card.footer.total_close_rate': '关闭率',
  'production.components.material_issue_total_card.footer.total_issue_severity_cnt': '严重以上',
  'production.components.material_issue_total_card.footer.total_issue_suspend_cnt': '挂起',
  'production.components.material_issue_total_card.footer.total_suspend_rate': '挂起率',
  'production.components.material_issue_total_card.tip':
    '统计物料问题数趋势，反映问题的跟进情况，请密切关注严重问题。关闭率反映问题的解决效率。',
  'production.components.material_issue_total_card.title': '来料不合格统计 (总数/待解决)',
  'production.components.material_ng_trend.count_flag.false': '显示数量',
  'production.components.material_ng_trend.count_flag.true': '显示次数',
  'production.components.material_ng_trend.legend.total': '总数',
  'production.components.material_ng_trend.series.total': '总数',
  'production.components.material_ng_trend.tip': '来料批次合格率',
  'production.components.material_ng_trend.title': '来料不良趋势',
  'production.components.material_ng_trend.y_axis.count_flag_cnt': '次数',
  'production.components.material_ng_trend.y_axis.count_flag_rate': '数量',
  'production.components.material_ok_card.bill': '批',
  'production.components.material_ok_card.footer.total_bill_ng_cnt': '不合格批次',
  'production.components.material_ok_card.footer.total_bill_ok_rate': '批次合格率',
  'production.components.material_ok_card.footer.total_mo_ok_rate': '物料合格率',
  'production.components.material_ok_card.tip':
    '统计来料情况，反映来料情况、质检情况。批次合格率越高代表供应商质量越好。如果没有选择供应商会统计所有。',
  'production.components.material_ok_card.title': '来料统计',
  'production.components.material_ok_category_card.mark_line_label_formatter': 'PPM及格线: {c}',
  'production.components.material_ok_category_card.tip': '统计物料退货, 退货率越高说明，说明供应商质量需要多加关注。',
  'production.components.material_ok_category_card.title': '来料不良PPM统计',
  'production.components.material_ok_category_card.y_axis_name': '分类',
  'production.components.material_ok_trend.bill_type_label': '请选择单据类型：',
  'production.components.material_ok_trend.bill_type_options.all': '全部',
  'production.components.material_ok_trend.bill_type_options.other': '其他',
  'production.components.material_ok_trend.bill_type_options.production': '量产',
  'production.components.material_ok_trend.bill_type_options.trial': '试产',
  'production.components.material_ok_trend.legend_data.bill_cnt': '总批次',
  'production.components.material_ok_trend.legend_data.bill_ng_cnt': '不合格批次',
  'production.components.material_ok_trend.legend_data.bill_ok_rate': '批次合格率',
  'production.components.material_ok_trend.mark_line_data_name.average': '平均',
  'production.components.material_ok_trend.tip':
    '批次合格率按照来料检验单批次统计，合格率越高代表来料质量越好，目标值：99%; 展示某时间范围、按照不同时间维度统计，可点击柱子查看来料问题',
  'production.components.material_ok_trend.tooltip_formatter.bill_cnt': '总批次',
  'production.components.material_ok_trend.tooltip_formatter.bill_ng_cnt': '不合格批次',
  'production.components.material_ok_trend.tooltip_formatter.bill_ok_rate': '批次合格率',
  'production.components.material_ok_trend.tooltip_formatter.material_cnt': '总物料数',
  'production.components.material_ok_trend.tooltip_formatter.material_ng_cnt': '不合格物料',
  'production.components.material_ok_trend.tooltip_formatter.material_ok_rate': '物料合格率',
  'production.components.material_return_ng_card.footer.total_ng_rate': '退货率',
  'production.components.material_return_ng_card.footer.total_sku_cnt': '退货物料种类',
  'production.components.material_return_ng_card.tip': '统计物料退货, 退货率越高说明，说明供应商质量需要多加关注。',
  'production.components.material_return_ng_card.title': '物料退货 (退货不良数/来料总数)',
  'production.components.report_layout.create_report_button': '当前条件下无报告, 点击创建报告',
  'production.components.report_layout.edit_button': '编辑',
  'production.components.report_layout.form_items.content.label': '报告内容',
  'production.components.report_layout.form_items.org_id.china': '国内',
  'production.components.report_layout.form_items.org_id.label': '所属组织',
  'production.components.report_layout.form_items.org_id.thailand': '泰国工厂',
  'production.components.report_layout.form_items.title.label': '报告名称',
  'production.components.report_layout.form_items.title.placeholder': '请输入名称',
  'production.components.report_layout.report_button': '当前报告',
  'production.components.report_layout.report_list_button': '报告列表',
  'production.components.report_layout.report_list_columns.end_date': '终止日期',
  'production.components.report_layout.report_list_columns.start_date': '起始日期',
  'production.components.report_layout.report_list_columns.title': '名称',
  'production.components.report_layout.save_button': '保存',
  'production.components.report_layout.save_success': '创建成功',
  'production.components.report_layout.update_success': '更新成功',
  'production.components.report_layout.view_report_button': '查看',
  'production.components.sqe_issue_closed_trend.legend_data.closeCnt': '关闭',
  'production.components.sqe_issue_closed_trend.legend_data.closeRate': '关闭率',
  'production.components.sqe_issue_closed_trend.legend_data.createCnt': '新建',
  'production.components.sqe_issue_closed_trend.legend_data.processCnt': '处理中',
  'production.components.sqe_issue_closed_trend.legend_data.solveCnt': '已解决',
  'production.components.sqe_issue_closed_trend.legend_data.suspendCnt': '挂起',
  'production.components.sqe_issue_closed_trend.tip':
    '来料问题关闭率，统计SQE对问题的处理情况，柱状图按责任人名下的问题数排序，最多的排在最左侧。',
  'production.components.sqe_issue_closed_trend.title': '来料问题关闭率',
  'production.components.sqe_issue_closed_trend.y_axis.issueCnt': '问题数量',
  'production.components.table_view.components.controller.overlay.column_setting': '列展示',
  'production.components.table_view.components.controller.overlay.large': '默认',
  'production.components.table_view.components.controller.overlay.middle': '中等',
  'production.components.table_view.components.controller.overlay.small': '紧凑',
  'production.components.timely_rate_of_inspection.legend_data.incoming': '来料批数',
  'production.components.timely_rate_of_inspection.legend_data.inspection': '检验批数',
  'production.components.timely_rate_of_inspection.legend_data.inspection_rate': '检验率',
  'production.components.timely_rate_of_inspection.series.incoming_cnt': '来料批数',
  'production.components.timely_rate_of_inspection.series.inspection_cnt': '检验批数',
  'production.components.timely_rate_of_inspection.series.inspection_rate': '检验率',
  'production.components.timely_rate_of_inspection.tip':
    '来料检验及时率的数据来源于k3的收料单、来料检验单，来料批数=收料单批次统计，检验批数=来料检验单批次统计，展示近14天的收料和来料检验对比，如果收料远远大于来料检验，则说明需要提高检验效率或补充IQC人力。',
  'production.components.timely_rate_of_inspection.title': '来料检验及时率',
  'production.components.timely_rate_of_inspection.y_axis.cnt': '批次数量',
  'production.components.timely_rate_of_inspection.y_axis.inspection_rate': '检验率',
  'production.constants.IssueSeverityEnum.critical': '严重',
  'production.constants.IssueSeverityEnum.fatal': '致命',
  'production.constants.IssueSeverityEnum.normal': '一般',
  'production.constants.IssueSeverityEnum.suggestive': '提示&建议',
  'production.constants.produceIssue.MaterialClassEnum.Optical': '光学',
  'production.constants.produceIssue.MaterialClassEnum.Structure': '结构',
  'production.constants.produceIssue.MaterialClassEnum.Electronic': '电子',
  'production.constants.produceIssue.MaterialClassEnum.Other': '其他',
  'production.constants.IssueStatusEnum.closed': '关闭',
  'production.constants.IssueStatusEnum.created': '新建',
  'production.constants.IssueStatusEnum.hangup': '挂起',
  'production.constants.IssueStatusEnum.processing': '处理中',
  'production.constants.IssueStatusEnum.solved': '已解决',
  'production.constants.MaterialInspectCategoryOptions.packageLabel': '包装',
  'production.constants.MaterialInspectCategoryOptions.appearance': '外观',
  'production.constants.MaterialInspectCategoryOptions.dimensions': '尺寸',
  'production.constants.MaterialInspectCategoryOptions.functionality': '功能',
  'production.constants.MaterialInspectCategoryOptions.reliability': '可靠性',
  'production.constants.MaterialInspectCategoryOptions.rohs': 'RoHS',
  'production.constants.factory_options.dangan': '大磡',
  'production.constants.factory_options.huizhou': '惠州',
  'production.constants.factory_options.skyworth_park': '创维园区',
  'production.constants.factory_options.thailand': '泰国',
  'production.constants.factory_options.yihua': '怡华',
  'production.constants.is_repair_options.continue_inspect': '是，继续检验',
  'production.constants.is_repair_options.no': '否',
  'production.constants.is_repair_options.re_inspect': '是，重新检验',
  'production.constants.pt_user_role_options.admin': '超级管理员',
  'production.constants.pt_user_role_options.engineer': '工程师',
  'production.constants.pt_user_role_options.tester': '测试员',
  'production.constants.pt_user_role_options.inspector': '检验员',
  'production.constants.pt_user_role_options.technician': '维修员',
  'production.constants.order_number_type_options.d2v_allocation_outbound_order': 'D2V调拨出库单',
  'production.constants.order_number_type_options.d2v_domestic_sales_outbound_order': 'D2V国内销售出库单',
  'production.constants.order_number_type_options.k3_sales_order': 'k3销售订单',
  'production.constants.produceIssue.InspectType.MachineTestOrder': '整机测试检验单',
  'production.constants.produceIssue.InspectType.PackageInspectOrder': '包装检验单',
  'production.constants.produceIssue.InspectType.ProcedureInspectionOrder': '巡检检验单',
  'production.constants.produceIssue.IssueClassEnum.MachineTestOrder': '整机测试检验单',
  'production.constants.produceIssue.IssueClassEnum.OutputInspectionOrder': '出货检验单',
  'production.constants.produceIssue.IssueClassEnum.PackageInspectOrder': '包装检验单',
  'production.constants.produceIssue.IssueClassEnum.ProcedureInspectionOrder': '巡检检验单',
  'production.constants.produceIssue.OrderStatus.NG': '不合格',
  'production.constants.produceIssue.OrderStatus.OK': '合格',
  'production.constants.produceIssue.OrderStatus.Unabled': '禁用',
  'production.constants.produceIssue.ProcessIssueType.IncomingMaterial': '来料',
  'production.constants.produceIssue.ProcessIssueType.Procedure': '制程',
  'production.constants.produceIssue.ProductStatusEnum.Machine': '整机',
  'production.constants.produceIssue.ProductStatusEnum.Module': '模块',
  'production.constants.produceIssue.QCDrawingTypeEnum.InspectionSpecification': '整机检测规范',
  'production.constants.produceIssue.QCDrawingTypeEnum.ProductionTestItem': '生产测试项',
  'production.constants.produceIssue.QCDrawingTypeEnum.QCProjectDrawing': 'QC工程图',
  'production.constants.produceIssue.RepairStatusEnum.Closed': '已关闭',
  'production.constants.produceIssue.RepairStatusEnum.Finished': '已完成',
  'production.constants.produceIssue.RepairStatusEnum.Processing': '处理中',
  'production.constants.produceIssue.RepairStatusEnum.Solved': '已解决',
  'production.constants.produceIssue.RepairStatusEnum.Waiting': '待处理',
  'production.constants.produceIssue.TestDepartment.Produce': '生产',
  'production.constants.produceIssue.TestDepartment.Quality': '品质',
  'production.dashboard.material_dashboard.components.iqc_ng_list.bill_nos': '相关来料单号',
  'production.dashboard.material_dashboard.components.iqc_ng_list.date': '日期',
  'production.dashboard.material_dashboard.components.iqc_ng_list.inspect_num': '不良数 / 检验数',
  'production.dashboard.material_dashboard.components.iqc_ng_list.is_key': '关键物料',
  'production.dashboard.material_dashboard.components.iqc_ng_list.issue_contents': '问题',
  'production.dashboard.material_dashboard.components.iqc_ng_list.issue_detail': '问题详情',
  'production.dashboard.material_dashboard.components.iqc_ng_list.material': '物料',
  'production.dashboard.material_dashboard.components.iqc_ng_list.material_class': '分类',
  'production.dashboard.material_dashboard.components.iqc_ng_list.material_number': '物料编码',
  'production.dashboard.material_dashboard.components.iqc_ng_list.operation': '操作',
  'production.dashboard.material_dashboard.components.iqc_ng_list.product_series_list': '关联产品系列',
  'production.dashboard.material_dashboard.components.iqc_ng_list.special_accept': '特采',
  'production.dashboard.material_dashboard.components.iqc_ng_list.specification': '规格型号',
  'production.dashboard.material_dashboard.components.iqc_ng_list.stock_name': '仓库',
  'production.dashboard.material_dashboard.components.iqc_ng_list.supplier': '供应商',
  'production.dashboard.material_dashboard.components.iqc_ng_list.total_record': '共{total}条数据',
  'production.dashboard.material_dashboard.components.iqc_ng_list.bill_count_summary':
    '对应 {billCount} 张不合格检验单（与柱子的不合格批次数一致），展开 {rowCount} 条料号明细',
  'production.dashboard.material_dashboard.components.iqc_ng_list.export': '导出当前明细',
  'production.dashboard.material_dashboard.issue_drawer.icqt_click_title': '来料合格率-不良物料明细（分类）',
  'production.dashboard.material_dashboard.issue_drawer.iqt_click_title': '来料合格率-不良物料明细（整体）',
  'production.dashboard.material_dashboard.ppm_upper_limit': '合格达标线(单位PPM)',
  'production.dashboard.material_dashboard.report.report_content':
    '<h3>《来料统计》分析</h3>\n\n<h3>《物料上线不良》分析</h3>\n\n<h3>《物料退货》分析</h3>\n\n<h3>《不合格统计》分析</h3>\n\n<h3>《未解决不合格》分析</h3>\n\n<h3>《挂起Bug》分析</h3>\n\n<h3>《批次合格率》分析</h3>\n\n<h3>《来料问题关闭率》分析</h3>\n\n<h3>《批次合格率-物料分类》分析</h3>\n\n<h3>《来料检验及时率》分析</h3>\n\n<h3>《来料检验活动图》分析</h3>',
  'production.dashboard.material_dashboard.report.report_title': '生产质量分析报告',
  'production.dashboard.material_dashboard.report.title': '报告',
  'production.dashboard.material_dashboard.ng_export': '不良问题导出',
  'production.dashboard.material_dashboard.title': '来料质量看板',
  'production.dashboard.procedure_dashboard.report_button': '报告',
  'production.dashboard.procedure_dashboard.title': '制程质量看板',
  'production.dashboard.supplier_dashboard.active_count': '活跃供应商',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.bill_cnt': '批次',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.bill_ng_cnt': '不合格批次',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.bill_ng_rate': '批次不合格率',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.check_issue': '查看问题',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.material_cnt': '物料总数（检验总数）',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.material_ng_cnt': '不良物料数',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.material_ng_rate': '物料不良率',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.operation': '操作',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.supplier': '供应商',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.title': '供应商质量总览',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.export': '导出',
  'production.dashboard.supplier_dashboard.components.supplier_ng_list.total_record': '共{total}条数据',
  'production.dashboard.supplier_dashboard.components.top_ok_rate.bill_ok_rate.description':
    '依据来料检验数据对供应商进行批次不合格统计，不合格越小，排名越靠前。',
  'production.dashboard.supplier_dashboard.components.top_ok_rate.bill_ok_rate.title': '批次不合格率排名-top10',
  'production.dashboard.supplier_dashboard.components.top_ok_rate.inspect_ok_rate.description':
    '依据来料检验数据对供应商进行物料不良率统计，不良率越小，排名越靠前。',
  'production.dashboard.supplier_dashboard.components.top_ok_rate.inspect_ok_rate.title': '物料不良率排名-top10',
  'production.dashboard.supplier_dashboard.form_item.org_id': '所属组织',
  'production.dashboard.supplier_dashboard.form_item.source.inner': '来料质检数据',
  'production.dashboard.supplier_dashboard.form_item.source.open': '供应商平台数据',
  'production.dashboard.supplier_dashboard.form_item.supplier.date_error': '日期格式错误',
  'production.dashboard.supplier_dashboard.form_item.supplier.get_open_supplier_list_fail':
    '获取开放平台供应商列表失败',
  'production.dashboard.supplier_dashboard.form_item.supplier.get_supplier_list_fail': '获取供应商列表失败',
  'production.dashboard.supplier_dashboard.form_item.supplier.name': '供应商',
  'production.dashboard.supplier_dashboard.form_item.supplier.tooltip':
    '供应商列表跟随选择日期，只会显示在选择日期范围内活跃的供应商',
  'production.dashboard.supplier_dashboard.form_item.supplier_code': '供应商代码',
  'production.dashboard.supplier_dashboard.inner_dashboard.material_ng_trend.title': '来料不良趋势',
  'production.dashboard.supplier_dashboard.inner_dashboard.title': '来料质检数据',
  'production.dashboard.supplier_dashboard.open_active_count': '开放平台活跃供应商',
  'production.dashboard.supplier_dashboard.open_dashboard.inspect_count.finished.tip':
    '已完成检验的产品总数(整个时间维度统计)',
  'production.dashboard.supplier_dashboard.open_dashboard.inspect_count.finished.title': '已检验数量',
  'production.dashboard.supplier_dashboard.open_dashboard.inspect_count.unfinished.tip':
    '已创建的检验单中未完成检验的产品总数(整个时间维度统计)',
  'production.dashboard.supplier_dashboard.open_dashboard.inspect_count.unfinished.title': '待检数量',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.bill_type_label': '请选择单据类型：',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.bill_type_options.all': '全部',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.bill_type_options.other': '其他',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.bill_type_options.production': '量产',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.bill_type_options.trial': '试产',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.legend_data.bill_cnt': '总批次',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.legend_data.bill_ng_cnt': '不合格批次',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.legend_data.bill_ok_rate': '批次合格率',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.mark_line.average': '平均',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tip':
    '批次合格率按照来料检验单批次统计，合格率越高代表来料质量越好，目标值：99%; 展示某时间范围、按照不同时间维度统计，可点击柱子查看来料问题',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.title': '来料批次合格率',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.bill_cnt': '总批次',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.bill_ng_cnt':
    '不合格批次',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.bill_ok_rate':
    '批次合格率',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.material_cnt': '总物料数',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.material_ng_cnt':
    '不合格物料',
  'production.dashboard.supplier_dashboard.open_dashboard.material_ok_trend.tooltip_formatter.material_ok_rate':
    '物料合格率',
  'production.dashboard.supplier_dashboard.open_dashboard.purchase_count.finished.tip':
    '检验单的产品总数等于客户订单的产品总数的订单数量(整个时间维度统计)',
  'production.dashboard.supplier_dashboard.open_dashboard.purchase_count.finished.title': '已完成订单数',
  'production.dashboard.supplier_dashboard.open_dashboard.purchase_count.unfinished.tip':
    '检验单的产品总数少于客户订单的产品总数的订单数量(整个时间维度统计)',
  'production.dashboard.supplier_dashboard.open_dashboard.purchase_count.unfinished.title': '未完成订单数',
  'production.dashboard.supplier_dashboard.open_dashboard.sort_card.bill_ok_rate.description':
    '依据来料检验数据对供应商进行批次良率统计，良率越小，排名越靠前。',
  'production.dashboard.supplier_dashboard.open_dashboard.sort_card.bill_ok_rate.title': '批次良率率排名-倒数top10',
  'production.dashboard.supplier_dashboard.open_dashboard.sort_card.inspect_ok_rate.description':
    '依据来料检验数据对供应商进行物料数量合格率统计，合格率越小，排名越靠前。',
  'production.dashboard.supplier_dashboard.open_dashboard.sort_card.inspect_ok_rate.title': '物料良率排名-倒数top10',
  'production.dashboard.supplier_dashboard.open_dashboard.title': '供应商平台数据',
  'production.dashboard.supplier_dashboard.title': '供应商质量看板',
  'production.dashboard.title': '看板',
  'production.material.inspect_order_detail.audit.button': '审核',
  'production.material.inspect_order_detail.audit.tip':
    '点击审核后，当前检验单据的状态会变为"已审核"，同时同步至K3系统，后续想要重新编辑需要小组长进行反审核操作',
  'production.material.inspect_order_detail.audit_wms.button': '审核',
  'production.material.inspect_order_detail.audit_wms.tip':
    '点击审核后，当前检验单据的状态会变为"已审核"，同时同步至WMS系统，后续想要重新编辑需要小组长进行反审核操作',
  'production.material.inspect_order_detail.audit_wms.confirm.title': '确认WMS审核',
  'production.material.inspect_order_detail.audit_wms.confirm.content':
    '确认审核检验单 {billNo} 吗？审核通过后将同步至WMS系统，无法在CTC系统中进行编辑',
  'production.material.inspect_order_detail.audit_success': '操作成功',
  'production.material.inspect_order_detail.before_unload': '当前页面有未保存的数据，确定离开？',
  'production.material.inspect_order_detail.cal_warning_text.no_assign': '检验单未分配，无操作权限',
  'production.material.inspect_order_detail.cal_warning_text.no_perm': '非指派检验员，无操作权限',
  'production.material.inspect_order_detail.cal_warning_text.leader_mode': '🟢 组长代操作模式',
  'production.material.inspect_order_detail.cal_warning_text.processing': '检验中......',
  'production.material.inspect_order_detail.cal_warning_text.re_audit':
    '重新审核状态下，检验单可继续编辑并保存; 确认所有单据修改完成后，可直接审核',
  'production.material.inspect_order_detail.cal_warning_text.wait':
    '检验单状态不是待检验，需要先点击开始检验，才能进行操作',
  'production.material.inspect_order_detail.create_issue.button': '创建问题单',
  'production.material.inspect_order_detail.create_issue.tip':
    '当前选中的物料检验单据检验结果为不合格，且未关联问题单，点击开始创建问题单',
  'production.material.inspect_order_detail.done.content':
    '确认检验完成{materialNumber}？确定后，检验状态标记为已完成，不可再编辑',
  'production.material.inspect_order_detail.done.success': '操作成功',
  'production.material.inspect_order_detail.done.title': '确认操作',
  'production.material.inspect_order_detail.done.unbind_issue': '检验结果失败，需要创建相关问题单',
  'production.material.inspect_order_detail.finish_inspect.button': '检验完成',
  'production.material.inspect_order_detail.finish_inspect.tip':
    '点击检验完成之后，当前选中的物料检验单据的检验状态会变为“已完成”，之后不可再编辑',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.assign_at': '分配时间',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.assigner_id': '分配人',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.bill_no': '单据编号',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.bill_status': '检验状态',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.inspector_id': '质检员',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.is_key': '关键物料',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.is_rush_order': '是否急单',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.urgent_status': '紧急状态',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.is_special_purchase': '是否特采',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.qc_finish_at': '检验完成时间',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.qc_start_at': '开始检验时间',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.receive_at': '收料下推时间',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.receive_bill_no': '收料编号',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.receiver_id': '收料下推人',
  'production.material.inspect_order_detail.inspect_order_base_info.form_items.status': '单据状态',
  'production.material.inspect_order_detail.inspect_order_base_info.title': '基本信息',
  'production.material.inspect_order_detail.inspect_order_detail_decision': '使用决策',
  'production.material.inspect_order_detail.inspect_order_detail_decision_rework': '返工-使用决策',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.accept_cnt': '允收数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.bill_status': '检验状态',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.index': '序号',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.inspect_cnt': '检验数量',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.inspect_result': '检验结果',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.inspector_id': '质检员',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.material_name': '物料名称',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.material_number': '物料编码',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.composite_code': '合成编码',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.qualified_cnt': '合格数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.reject_cnt': '拒收数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.sample_cnt': '样本数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.sample_damage_cnt': '样本损坏数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.sample_unqualified_cnt':
    '样本不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.specification': '规格型号',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.area_stock_name': '仓库',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.stock_name': '库区',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.supplier': '供应商',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.columns.unqualified_cnt': '不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_entry_list.title': '分录明细',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.attachment': '附件',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.inspect_result': '检验结果',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.is_special_purchase': '是否特采',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.qualified_cnt': '合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.remark': '备注',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.sample_damage_cnt': '样本损坏数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.sample_damage_tray':
    '破坏检验来源托盘',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.sample_unqualified_cnt':
    '样本不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.unqualified_cnt': '不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.form_items.conditional_accept_cnt':
    '让步接收数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.rework_button': '返工',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.rework_tip':
    '当检验不合格且还未审核时可选择返工重新检验，通过<特采><现场修改><线上修改>的方式完成返工工序并重新填写检验数据。',
  'production.material.inspect_order_detail.inspect_order_detail_inspect.title': '检验结果',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_inspect_result':
    '检验结果',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_method': '返工方式',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_qualified_cnt':
    '合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_conditional_accept_cnt':
    '让步接收数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_sample_damage_cnt':
    '样本破坏数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_sample_damage_tray':
    '破坏检验来源托盘',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_sample_unqualified_cnt':
    '样本不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.form_items.rework_unqualified_cnt':
    '不合格数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.button': '提交',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_inspect_result':
    '请选择检验结果！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_method':
    '请选择返工方式！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_qualified_cnt':
    '请输入合格数！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_sample_damage_cnt':
    '请输入样本破坏数',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_sample_unqualified_cnt':
    '请输入样本不合格数！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_unqualified_cnt':
    '请输入不合格数！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.rework_conditional_accept_cnt':
    '请输入让步接收数！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.submit.success': '保存成功！',
  'production.material.inspect_order_detail.inspect_order_detail_inspect_rework.title': '返工检验结果',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.index': '序号',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.material_name': '物料名称',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.composite_code': '合成编码',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.material_number': '物料编码',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.material_phase': '物料阶段',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.specification': '规格',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.area_stock_name': '仓库',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.stock_name': '库区',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.supplier': '供应商',
  'production.material.inspect_order_detail.inspect_order_detail_material.form_items.project_code': '项目编码',
  'production.material.inspect_order_detail.inspect_order_detail_material.title': '基本信息',
  'production.material.inspect_order_detail.inspect_order_detail_material_inspect': '物料检验',
  'production.material.inspect_order_detail.inspect_order_detail_policy_detail.form_items.index': '序号',
  'production.material.inspect_order_detail.inspect_order_detail_policy_detail.form_items.policy_qty': '决策数量',
  'production.material.inspect_order_detail.inspect_order_detail_policy_detail.form_items.policy_status': '状态',
  'production.material.inspect_order_detail.inspect_order_detail_policy_detail.form_items.use_policy': '使用决策',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.add.add_group': '添加多组(列)',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.add.add_row': '添加多行数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.add.alert_max_group':
    '最多支持100组数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.add.alert_max_row':
    '最多支持100行数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p1':
    '1. 测量工具行，双击可进行选择',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p2':
    '2. 标准偏差上限、标准偏差下限、数据行，均只能填写数值',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p3':
    '3. 数据行填写测量数据，符合标准范围的显示绿色，不符合的显示红色',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p4':
    '4. 编辑状态下，可动态添加组数据和行数据，总数不能超过100组和100行数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p5':
    '5. 编辑状态下，选中列头，鼠标右键可以删除列；选中单元格，可以删除行；总数不能低于5组和5行数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.p6':
    '6. 参考案例如下：',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.description.title': '使用说明',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.export.button': '导出',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.export.file_name':
    '来料检验数据({billNo}-{materialNumber})',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.export.s_instance_data_title':
    '尺寸记录表',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.fixed_col_headers': '尺寸序号',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.fixed_row_headers.measurement_tool':
    '测量工具',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.fixed_row_headers.standard_deviation_lower_limit':
    '标准偏差下限',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.fixed_row_headers.standard_deviation_upper_limit':
    '标准偏差上限',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.fixed_row_headers.standard_size':
    '标准尺寸',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.on_before_delete':
    '当前位置不可删除',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.on_before_delete_col':
    '最少保留{min_col_num}列数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.on_before_delete_row':
    '最少保留{min_row_num}行数据',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.save.button': '保存',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.save.success': '保存成功！',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.sync.button': '同步上一次标准',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.sync.content':
    '点击确认后，会使用最近一次的检验数据，覆盖当前的标准数据（检测数据不变）',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.sync.title':
    '同步 {materialNumber} 上一次的检验标准',
  'production.material.inspect_order_detail.inspect_order_detail_record_measurement.title': '尺寸记录表',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.accept_cnt': '允收数',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.inspect_cnt': '批量(检验数量)',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.inspect_level': '检验水平',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.reject_cnt': '拒收数',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.sample_cnt': '样本数',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.sample_type': '抽样类型',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.scheme_name': '抽样方案',
  'production.material.inspect_order_detail.inspect_order_detail_sample.form_items.strict_level': '严格度',
  'production.material.inspect_order_detail.inspect_order_detail_sample.title': '整体抽样',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.attachment': '附件',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.attachment_link': '附件链接',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.design_drawings': '设计稿/图纸',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.is_common': '是否通用',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.name': '检验规范',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.plm_system_link': '图纸信息',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.plm_system_link_text': '打开PLM系统',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.sample_ack_letter': '样品承认书',
  'production.material.inspect_order_detail.inspect_order_detail_spec.form_items.version': '版本',
  'production.material.inspect_order_detail.inspect_order_detail_spec.title': '检验规范',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.add_group': '添加测量组数',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.inspect_cnt':
    '检验数',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.inspect_item':
    '检验项目',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.inspect_remark':
    '备注说明',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.inspect_standard':
    '检验标准',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.inspect_tool':
    '检验工具',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.unqualified_cnt':
    '不良数',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.headers.unqualified_rate':
    '不良率',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.appearance.title': '外观记录表',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.check_un_save':
    '{label}检验数据未保存，请先保存',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.export.button': '导出',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.export.file_name':
    '来料检验数据({billNo}-{materialNumber})',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.function.title': '功能记录表',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.reliability.title': '可靠性记录表',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.save.button': '保存',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.save.success': '保存成功！',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.spec_drawer_button': '检验规范标准',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.title': '检验数据记录',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_alert':
    '物料检验规范存在更新的版本，点击',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.button':
    '手动更新',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.content':
    '确定更新至最新的检验规范版本吗？更新后，六类记录表的检验标准和抽样方案会更新。',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.content_with_record':
    '确定更新至最新的检验规范版本吗？更新后，六类记录表的检验标准和抽样方案会更新，已保存数据会保留，请更新后复核。',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.content_with_unsaved':
    '检测到有未保存的检验数据，确定后将先保存当前编辑再更新规范。是否继续？',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.no_latest_spec':
    '当前物料没有最新检验规范，请稍后再试',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.same_spec':
    '当前检验规范已经是最新的了',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.success':
    '更新成功',
  'production.material.inspect_order_detail.inspect_order_detail_spec_items_record.update_to_latest_spec.title':
    '更新至检验规范',
  'production.material.inspect_order_detail.issue_bill.form_items.assignee': '指派人(SQE)',
  'production.material.inspect_order_detail.issue_bill.form_items.attachment': '附件',
  'production.material.inspect_order_detail.issue_bill.form_items.badPicture': '不良图片',
  'production.material.inspect_order_detail.issue_bill.form_items.cause': '异常发生原因',
  'production.material.inspect_order_detail.issue_bill.form_items.description': '问题描述',
  'production.material.inspect_order_detail.issue_bill.form_items.handle': '应急处置',
  'production.material.inspect_order_detail.issue_bill.form_items.improve': '改善对策',
  'production.material.inspect_order_detail.issue_bill.form_items.issueClass': '不良分类',
  'production.material.inspect_order_detail.issue_bill.form_items.issueSeverity': '严重程度',
  'production.material.inspect_order_detail.issue_bill.form_items.priority': '优先级',
  'production.material.inspect_order_detail.issue_bill.form_items.result': '应急处理结果',
  'production.material.inspect_order_detail.issue_bill.form_items.status': '问题状态',
  'production.material.inspect_order_detail.issue_bill.title': '问题单据',
  'production.material.inspect_order_detail.no_sample_scheme': '物料{materialNumber}未绑定抽样方案',
  'production.material.inspect_order_detail.request_materials_fail': '未找到该检验单下的详情数据',
  'production.material.inspect_order_detail.view.button': '查看供应商检验单',
  'production.material.inspect_order_detail.start_inspect.button': '开始检验',
  'production.material.inspect_order_detail.start_inspect.tip':
    '点击开始检验之后，当前选中的物料检验单据的检验状态会变为“检验中”，同时记录开始检验时间，统计检验过程时间',
  'production.material.inspect_order_detail.title': '来料检验单据',
  'production.material.inspect_order_list.title': '来料检验单',
  'production.material.inspect_scheme.title': '来料检验方案',
  'production.material.inspect_scheme.ai.title': 'AI 创建来料检验方案',
  'production.material.issue.actions.delete': '删除',
  'production.material.issue.actions.delete_modal.content': '删除后不可恢复，是否确认删除？',
  'production.material.issue.actions.delete_modal.success': '删除成功',
  'production.material.issue.actions.delete_modal.title': '删除确认:',
  'production.material.issue.actions.edit': '编辑',
  'production.material.issue.columns.attachment': '附件',
  'production.material.issue.columns.badCount': '不合格数',
  'production.material.issue.columns.badPicture': '不良图片',
  'production.material.issue.columns.cause': '异常发生原因',
  'production.material.issue.columns.checkBadCount': '样本不合格数量',
  'production.material.issue.columns.checkCount': '样本数量',
  'production.material.issue.columns.createBy': '创建者',
  'production.material.issue.columns.createdAt': '创建日期',
  'production.material.issue.columns.description': '问题描述',
  'production.material.issue.columns.handle': '应急处置',
  'production.material.issue.columns.id': 'ID',
  'production.material.issue.columns.improve': '改善对策',
  'production.material.issue.columns.incomingCount': '来料数量',
  'production.material.issue.columns.incomingOrderNo': '来料单号',
  'production.material.issue.columns.issueClass': '不良分类',
  'production.material.issue.columns.affectsYield': '是否影响直通率',
  'production.material.issue.columns.issueSeverity': '严重程度',
  'production.material.issue.columns.materialClass': '物料分类',
  'production.material.issue.columns.materialPhase': '物料阶段',
  'production.material.issue.columns.materialName': '物料名称',
  'production.material.issue.columns.materialNo': '物料编码',
  'production.material.issue.columns.compositeCode': '合成编码',
  'production.material.issue.columns.projectCode': '项目编码',
  'production.material.issue.columns.projectStage': '项目阶段',
  'production.material.issue.columns.factory': '厂区',
  'production.material.issue.columns.priority': '优先级',
  'production.material.issue.columns.result': '应急处理结果',
  'production.material.issue.columns.specification': '规格型号',
  'production.material.issue.columns.status': '处理状态',
  'production.material.issue.columns.supplier': '供应商名称',
  'production.material.issue.columns.updateBy': '更新者',
  'production.material.issue.columns.updatedAt': '更新日期',
  'production.material.issue.columns.user': '指派人',
  'production.material.issue.create_modal.modal_title': '创建问题',
  'production.material.issue.form.incomingInspection.badCount': '不合格数',
  'production.material.issue.form.incomingInspection.domestic': '国内',
  'production.material.issue.form.incomingInspection.incomingCount': '来料数量',
  'production.material.issue.form.incomingInspection.incomingOrderNo': '来料单号',
  'production.material.issue.form.incomingInspection.incomingOrderNoWithCode': '来料单号(物料编码)',
  'production.material.issue.form.incomingInspection.materialCode': '物料编码',
  'production.material.issue.form.incomingInspection.materialPhase': '物料阶段',
  'production.material.issue.form.incomingInspection.projectCode': '项目编码',
  'production.material.issue.form.incomingInspection.projectStage': '项目阶段',
  'production.material.issue.form.incomingInspection.factory': '厂区',
  'production.material.issue.form.incomingInspection.compositeCode': '合成编码',
  'production.material.issue.form.incomingInspection.materialName': '物料名称',
  'production.material.issue.form.incomingInspection.materialType': '物料类型',
  'production.material.issue.form.incomingInspection.organization': '所属组织',
  'production.material.issue.form.incomingInspection.remoteMode': '(仅可选择指派人为您的来料单号)',
  'production.material.issue.form.incomingInspection.sampleBadCount': '样本不合格数',
  'production.material.issue.form.incomingInspection.sampleCount': '样本数量',
  'production.material.issue.form.incomingInspection.specification': '规格',
  'production.material.issue.form.incomingInspection.supplierName': '供应商名称',
  'production.material.issue.form.incomingInspection.thailandFactory': '泰国工厂',
  'production.material.issue.form.incomingInspection.title': '来料检验信息',
  'production.material.issue.form.issueManagement.assignee': '指派人(SQE)',
  'production.material.issue.form.issueManagement.assigneeRequired': '请选择指派人',
  'production.material.issue.form.issueManagement.attachment': '附件',
  'production.material.issue.form.issueManagement.badPictures': '不良图片',
  'production.material.issue.form.issueManagement.cause': '异常发生原因',
  'production.material.issue.form.issueManagement.description': '问题描述',
  'production.material.issue.form.issueManagement.descriptionRequired': '请填写问题描述',
  'production.material.issue.form.issueManagement.emergencyResponse': '应急处置',
  'production.material.issue.form.issueManagement.emergencyResponseRequired': '请选择应急处置',
  'production.material.issue.form.issueManagement.emergencyResult': '应急处理结果',
  'production.material.issue.form.issueManagement.emergencyResultRequired': '请输入应急处理结果',
  'production.material.issue.form.issueManagement.improvement': '改善对策',
  'production.material.issue.form.issueManagement.issueClass': '不良分类',
  'production.material.issue.form.issueManagement.issueClassRequired': '请选择不良分类',
  'production.material.issue.form.issueManagement.affectsYield': '是否影响直通率',
  'production.material.issue.form.issueManagement.priority': '优先级',
  'production.material.issue.form.issueManagement.priorityRequired': '请选择问题优先级',
  'production.material.issue.form.issueManagement.severity': '严重程度',
  'production.material.issue.form.issueManagement.status': '问题状态',
  'production.material.issue.form.issueManagement.title': '问题管理（进度跟踪）',
  'production.material.issue.form.issueManagement.updateModalTitle': '编辑问题',
  'production.material.issue.title': '来料问题库',
  'production.material.issue.tools.create_button': '创建问题单',
  'production.material.issue.tools.export_button': '导出',
  'production.material.issue.tools.export_success': '导出成功, 请在下载文件中查看',
  'production.material.wms_receive_bill.title': 'WMS-收料单',
  'production.material.receive_bill.title': 'K3-收料单',
  'production.material.samples.title': '样品管理',
  'production.material.title': '来料',
  'production.produceIssue.columns.attachmentDefectiveProductPhoto': '不良品项附件',
  'production.produceIssue.columns.attachmentSolutionFile': '解决方案文件附件',
  'production.produceIssue.columns.badAttribution': '异常归属',
  'production.produceIssue.columns.badCategory1': '不良分类',
  'production.produceIssue.columns.badCategory2': '不良项',
  'production.produceIssue.columns.badMeasure': '不良对策',
  'production.produceIssue.columns.causeAnalysis': '原因分析',
  'production.produceIssue.columns.createBy': '创建者',
  'production.produceIssue.columns.createdAt': '创建日期',
  'production.produceIssue.columns.id': 'ID',
  'production.produceIssue.columns.inspectClass': '发现工序',
  'production.produceIssue.columns.issueCls': '检验单',
  'production.produceIssue.columns.issueContent': '问题描述',
  'production.produceIssue.columns.issueSeverity': '严重程度',
  'production.produceIssue.columns.affectsYield': '是否影响直通率',
  'production.produceIssue.columns.materialBatch': '物料批次',
  'production.produceIssue.columns.materialClass': '分类',
  'production.produceIssue.columns.materialName': '物料名称',
  'production.produceIssue.columns.remark': '备注',
  'production.produceIssue.columns.responsible': '责任人',
  'production.produceIssue.columns.seriesId': '系列',
  'production.produceIssue.columns.sku': '物料编码',
  'production.produceIssue.columns.compositeCode': '合成编码',
  'production.produceIssue.columns.solution': '解决方案',
  'production.produceIssue.columns.status': '问题状态',
  'production.produceIssue.columns.supplier': '供应商',
  'production.produceIssue.columns.sysProjectId': '产品项目',
  'production.produceIssue.columns.updateBy': '更新者',
  'production.produceIssue.columns.updatedAt': '更新日期',
  'production.produceIssue.constants.QCDrawingStatus.Approved': '已批准',
  'production.produceIssue.constants.QCDrawingStatus.Audited': '待批准',
  'production.produceIssue.constants.QCDrawingStatus.Prepare': '待审核',
  'production.produceIssue.create_model.title': '创建制程问题单',
  'production.produceIssue.edit_model.title': '编辑制程问题单: {id}',
  'production.produceIssue.form_items.attachmentDefectiveProductPhoto': '不良项附件',
  'production.produceIssue.form_items.badAttributionID': '异常归属',
  'production.produceIssue.form_items.badCategoryId1': '不良分类',
  'production.produceIssue.form_items.badCategoryId2': '不良项',
  'production.produceIssue.form_items.badCount': '不良数',
  'production.produceIssue.form_items.checkCount': '抽检数',
  'production.produceIssue.form_items.handleDetail.attachmentSolutionFile': '解决方案文件附件',
  'production.produceIssue.form_items.handleDetail.badMeasureId': '不良对策',
  'production.produceIssue.form_items.handleDetail.causeAnalysis': '原因分析',
  'production.produceIssue.form_items.handleDetail.label': '处理详情',
  'production.produceIssue.form_items.handleDetail.remark': '备注',
  'production.produceIssue.form_items.handleDetail.responsible': '责任人',
  'production.produceIssue.form_items.handleDetail.solution': '解决方案',
  'production.produceIssue.form_items.inspectClassID': '发现工序',
  'production.produceIssue.form_items.inspectOrderId': '检测单ID',
  'production.produceIssue.form_items.issueCls': '检验类型',
  'production.produceIssue.form_items.issueContent': '问题描述',
  'production.produceIssue.form_items.issueDetail': '问题详情',
  'production.produceIssue.form_items.issueSeverity': '严重程度',
  'production.produceIssue.form_items.affectsYield': '是否影响直通率',
  'production.produceIssue.form_items.materialBatch': '物料批次',
  'production.produceIssue.form_items.materialName': '物料名称',
  'production.produceIssue.form_items.orgId.label.china': '国内',
  'production.produceIssue.form_items.orgId.label.thailand': '泰国工厂',
  'production.produceIssue.form_items.orgId.title': '所属组织',
  'production.produceIssue.form_items.remark': '备注',
  'production.produceIssue.form_items.seriesId.label': '系列',
  'production.produceIssue.form_items.sku': '物料编码',
  'production.produceIssue.form_items.compositeCode': '合成编码',
  'production.produceIssue.form_items.status': '问题状态',
  'production.produceIssue.form_items.supplier': '供应商',
  'production.produceIssue.form_items.sysProjectId.label': '系统硬件项目',
  'production.produceIssue.form_items.sysProjectId.tooltip': '产品项目',
  'production.produceIssue.form_items.total': '投入数',
  'production.produceIssue.title': '制程问题库',
  'production.shipments.accreditation_type_enum.domestic_order': '国内单',
  'production.shipments.accreditation_type_enum.domestic_review': '国内评审单',
  'production.shipments.accreditation_type_enum.overseas_order': '海外单',
  'production.shipments.accreditation_type_enum.overseas_review': '海外评审单',
  'production.shipments.inspect_detail.columns.bad_count': '不良数量',
  'production.shipments.inspect_detail.columns.check_count': '检验数量',
  'production.shipments.inspect_detail.columns.create_by': '创建者',
  'production.shipments.inspect_detail.columns.created_at': '创建日期',
  'production.shipments.inspect_detail.columns.id': 'ID',
  'production.shipments.inspect_detail.columns.is_unbox': '是否开箱',
  'production.shipments.inspect_detail.columns.material_name': '物料名称',
  'production.shipments.inspect_detail.columns.order_number': '订单号',
  'production.shipments.inspect_detail.columns.order_number_type': '订单号类型',
  'production.shipments.inspect_detail.columns.out_count': '出货数量',
  'production.shipments.inspect_detail.columns.pictures': '图片',
  'production.shipments.inspect_detail.columns.remarks': '备注',
  'production.shipments.inspect_detail.columns.sku': '物料编码',
  'production.shipments.inspect_detail.columns.composite_code': '合成编码',
  'production.shipments.inspect_detail.columns.status': '检测结果',
  'production.shipments.inspect_detail.columns.unbox_sn': '开箱SN码',
  'production.shipments.inspect_detail.columns.update_by': '更新者',
  'production.shipments.inspect_detail.columns.updated_at': '更新日期',
  'production.shipments.inspect_detail.form_items.inspection_data.bad_count': '不良数量',
  'production.shipments.inspect_detail.form_items.inspection_data.check_count.label': '检验数量',
  'production.shipments.inspect_detail.form_items.inspection_data.check_count.message': '请输入检验数量',
  'production.shipments.inspect_detail.form_items.inspection_data.check_record.inspect_spec': '检验标准',
  'production.shipments.inspect_detail.form_items.inspection_data.check_record.label': '检验规范',
  'production.shipments.inspect_detail.form_items.inspection_data.check_record.name': '检验点',
  'production.shipments.inspect_detail.form_items.inspection_data.check_record.result': '结果',
  'production.shipments.inspect_detail.form_items.inspection_data.label': '检验数据',
  'production.shipments.inspect_detail.form_items.inspection_data.pictures': '图片附件',
  'production.shipments.inspect_detail.form_items.inspection_data.remarks': '备注',
  'production.shipments.inspect_detail.form_items.inspection_data.status': '检验结果',
  'production.shipments.inspect_detail.form_items.inspection_info.is_unbox': '是否开箱',
  'production.shipments.inspect_detail.form_items.inspection_info.label': '检验信息',
  'production.shipments.inspect_detail.form_items.inspection_info.material_name': '物料名称',
  'production.shipments.inspect_detail.form_items.inspection_info.order_number': '订单号',
  'production.shipments.inspect_detail.form_items.inspection_info.out_count': '出货数量',
  'production.shipments.inspect_detail.form_items.inspection_info.sku': '物料编码',
  'production.shipments.inspect_detail.form_items.inspection_info.composite_code': '合成编码',
  'production.shipments.inspect_detail.form_items.inspection_info.unbox_sn': '开箱SN码',
  'production.shipments.inspect_detail.read.text': '查看',
  'production.shipments.inspect_detail.read.title': '出货检验单明细详情: {id}',
  'production.shipments.inspect_detail.title': '出货单明细',
  'production.shipments.inspect_detail.update.text': '更新',
  'production.shipments.inspect_order.columns.accreditation_picture': '评审图片',
  'production.shipments.inspect_order.columns.accreditation_requirements': '评审需求',
  'production.shipments.inspect_order.columns.accreditation_type': '评审单分类',
  'production.shipments.inspect_order.columns.check_count': '检验数量',
  'production.shipments.inspect_order.columns.create_by': '创建者',
  'production.shipments.inspect_order.columns.created_at': '创建日期',
  'production.shipments.inspect_order.columns.factory': '所在工厂',
  'production.shipments.inspect_order.columns.id': 'ID',
  'production.shipments.inspect_order.columns.order_count': '订单总数',
  'production.shipments.inspect_order.columns.order_number': '订单号',
  'production.shipments.inspect_order.columns.order_number_type': '订单号类型',
  'production.shipments.inspect_order.columns.output_confirm': '出货确认人',
  'production.shipments.inspect_order.columns.remarks': '备注',
  'production.shipments.inspect_order.columns.status': '检测结果',
  'production.shipments.inspect_order.columns.update_by': '更新者',
  'production.shipments.inspect_order.columns.updated_at': '更新日期',
  'production.shipments.inspect_order.create.button': '创建',
  'production.shipments.inspect_order.create.modal_title': '创建K3出货检验',
  'production.shipments.inspect_order.delete.button': '删除',
  'production.shipments.inspect_order.delete.content': '删除后不可恢复，是否确认删除？',
  'production.shipments.inspect_order.delete.modal_title': '删除确认: {id}',
  'production.shipments.inspect_order.detail.button': '明细',
  'production.shipments.inspect_order.form_items.accreditation_picture': '评审图片',
  'production.shipments.inspect_order.form_items.accreditation_requirements': '评审需求',
  'production.shipments.inspect_order.form_items.accreditation_type': '评审单分类',
  'production.shipments.inspect_order.form_items.check_count': '检验数量',
  'production.shipments.inspect_order.form_items.check_list.inspect_spec': '检验标准',
  'production.shipments.inspect_order.form_items.check_list.label': '检验内容',
  'production.shipments.inspect_order.form_items.check_list.name': '检验点',
  'production.shipments.inspect_order.form_items.detail.label': '订单明细',
  'production.shipments.inspect_order.form_items.detail.material_name': '物料名称',
  'production.shipments.inspect_order.form_items.detail.material_number': '物料编号',
  'production.shipments.inspect_order.form_items.detail.composite_code': '合成编码',
  'production.shipments.inspect_order.form_items.detail.order_date': '订单日期',
  'production.shipments.inspect_order.form_items.detail.order_no': '订单编号',
  'production.shipments.inspect_order.form_items.detail.quantity': '出货数量',
  'production.shipments.inspect_order.form_items.factory': '所在工厂',
  'production.shipments.inspect_order.form_items.inspect_spec': '检验规范',
  'production.shipments.inspect_order.form_items.order_count': '订单总数',
  'production.shipments.inspect_order.form_items.order_info': '订单信息',
  'production.shipments.inspect_order.form_items.order_number': '订单号',
  'production.shipments.inspect_order.form_items.order_number_type': '订单号类型',
  'production.shipments.inspect_order.form_items.output_confirm': '出货确认人',
  'production.shipments.inspect_order.form_items.remarks': '备注',
  'production.shipments.inspect_order.title': 'K3出货检验',
  'production.shipments.inspect_order.update.button': '编辑',
  'production.shipments.inspect_order.update.modal_title': '编辑K3出货检验',
  'production.shipments.wms_inspect_order.title': 'WMS出货检验单',
  'production.shipments.wms_inspect_order.columns.accreditation_picture': '评审图片',
  'production.shipments.wms_inspect_order.columns.accreditation_requirements': '评审需求',
  'production.shipments.wms_inspect_order.columns.accreditation_type': '评审单分类',
  'production.shipments.wms_inspect_order.columns.check_count': '检验数量',
  'production.shipments.wms_inspect_order.columns.create_by': '创建者',
  'production.shipments.wms_inspect_order.columns.created_at': '创建日期',
  'production.shipments.wms_inspect_order.columns.factory': '所在工厂',
  'production.shipments.wms_inspect_order.columns.id': 'ID',
  'production.shipments.wms_inspect_order.columns.order_count': '订单总数',
  'production.shipments.wms_inspect_order.columns.order_number': '订单号',
  'production.shipments.wms_inspect_order.columns.order_number_type': '订单号类型',
  'production.shipments.wms_inspect_order.columns.material_number': '物料编号',
  'production.shipments.wms_inspect_order.columns.material_name': '物料名称',
  'production.shipments.wms_inspect_order.columns.output_confirm_by': '出货确认人',
  'production.shipments.wms_inspect_order.columns.out_count': '出货数量',
  'production.shipments.wms_inspect_order.columns.bad_count': '不良数量',
  'production.shipments.wms_inspect_order.columns.warehouse': '仓库',
  'production.shipments.wms_inspect_order.columns.remarks': '备注',
  'production.shipments.wms_inspect_order.columns.status': '检测结果',
  'production.shipments.wms_inspect_order.columns.update_by': '更新者',
  'production.shipments.wms_inspect_order.columns.updated_at': '更新日期',
  'production.shipments.wms_inspect_order.create.button': '创建',
  'production.shipments.wms_inspect_order.create.modal_title': '创建WMS出货检验',
  'production.shipments.wms_inspect_order.delete.button': '删除',
  'production.shipments.wms_inspect_order.delete.content': '删除后不可恢复，是否确认删除？',
  'production.shipments.wms_inspect_order.delete.modal_title': '删除确认: {id}',
  'production.shipments.wms_inspect_order.detail.button': '明细',
  'production.shipments.wms_inspect_order.form_items.accreditation_picture': '评审图片',
  'production.shipments.wms_inspect_order.form_items.accreditation_requirements': '评审需求',
  'production.shipments.wms_inspect_order.form_items.accreditation_type': '评审单分类',
  'production.shipments.wms_inspect_order.form_items.check_count': '检验数量',
  'production.shipments.wms_inspect_order.form_items.check_list.inspect_spec': '检验标准',
  'production.shipments.wms_inspect_order.form_items.check_list.label': '检验内容',
  'production.shipments.wms_inspect_order.form_items.check_list.name': '检验点',
  'production.shipments.wms_inspect_order.form_items.detail.label': '订单明细',
  'production.shipments.wms_inspect_order.form_items.detail.material_name': '物料名称',
  'production.shipments.wms_inspect_order.form_items.detail.material_number': '物料编号',
  'production.shipments.wms_inspect_order.form_items.detail.composite_code': '合成编码',
  'production.shipments.wms_inspect_order.form_items.detail.order_date': '订单日期',
  'production.shipments.wms_inspect_order.form_items.detail.order_no': '订单编号',
  'production.shipments.wms_inspect_order.form_items.detail.quantity': '出货数量',
  'production.shipments.wms_inspect_order.form_items.factory': '所在工厂',
  'production.shipments.wms_inspect_order.form_items.inspect_spec': '检验规范',
  'production.shipments.wms_inspect_order.form_items.order_count': '订单总数',
  'production.shipments.wms_inspect_order.form_items.order_info': '订单信息',
  'production.shipments.wms_inspect_order.form_items.order_number': '订单号',
  'production.shipments.wms_inspect_order.form_items.order_number_type': '订单号类型',
  'production.shipments.wms_inspect_order.form_items.material_number': '物料编号',
  'production.shipments.wms_inspect_order.form_items.material_name': '物料名称',
  'production.shipments.wms_inspect_order.form_items.output_confirm_by': '出货确认人',
  'production.shipments.wms_inspect_order.form_items.out_count': '出货数量',
  'production.shipments.wms_inspect_order.form_items.bad_count': '不良数量',
  'production.shipments.wms_inspect_order.form_items.warehouse': '仓库',
  'production.shipments.wms_inspect_order.form_items.check_record.label': '检验记录',
  'production.shipments.wms_inspect_order.form_items.check_record.sn': '序列号',
  'production.shipments.wms_inspect_order.form_items.check_record.status': '状态',
  'production.shipments.wms_inspect_order.form_items.check_record.summary': '检验总结',
  'production.shipments.wms_inspect_order.form_items.check_record.inspector': '检验员',
  'production.shipments.wms_inspect_order.form_items.check_record.inspect_time': '检验时间',
  'production.shipments.wms_inspect_order.form_items.remarks': '备注',
  'production.shipments.wms_inspect_order.update.button': '编辑',
  'production.shipments.wms_inspect_order.update.modal_title': '编辑WMS出货检验',
  'production.shipments.wms_inspect_detail.title': 'WMS检验单明细',
  'production.shipments.wms_inspect_detail.read.title': 'WMS检验单明细详情: {id}',
  'production.shipments.wms_inspect_detail.read.text': '查看',
  'production.shipments.wms_inspect_detail.update.text': '更新',
  'production.shipments.wms_inspect_detail.inspect_items.title': '检验项列表 - {sn}',
  'production.shipments.wms_inspect_detail.inspect_items.button': '查看检验项',
  'production.shipments.wms_inspect_detail.inspect_items.columns.item_name': '检验项名称',
  'production.shipments.wms_inspect_detail.inspect_items.columns.standard': '检验标准',
  'production.shipments.wms_inspect_detail.inspect_items.columns.result': '检验结果',
  'production.shipments.wms_inspect_detail.columns.sn': 'SN',
  'production.shipments.wms_inspect_detail.columns.lot_number': '批次号',
  'production.shipments.wms_inspect_detail.columns.status': '检验结果',
  'production.shipments.wms_inspect_detail.columns.summary': '检验总结',
  'production.shipments.wms_inspect_detail.columns.inspector': '检验人',
  'production.shipments.wms_inspect_detail.columns.inspect_time': '检验时间',
  'production.shipments.wms_inspect_detail.columns.pictures': '检验图片',
  'production.shipments.wms_inspect_detail.columns.order_number': '订单号',
  'production.shipments.wms_inspect_detail.columns.order_number_type': '订单号类型',
  'production.shipments.wms_inspect_detail.columns.material_number': '物料编号',
  'production.shipments.wms_inspect_detail.columns.material_name': '物料名称',
  'production.shipments.wms_inspect_detail.columns.out_count': '出货数量',
  'production.shipments.wms_inspect_detail.columns.check_count': '检验数量',
  'production.shipments.wms_inspect_detail.columns.bad_count': '不良数量',
  'production.shipments.wms_inspect_detail.columns.warehouse': '仓库',
  'production.shipments.wms_inspect_detail.columns.remarks': '备注',
  'production.shipments.wms_inspect_detail.columns.create_by': '创建者',
  'production.shipments.wms_inspect_detail.columns.update_by': '更新者',
  'production.shipments.wms_inspect_detail.columns.created_at': '创建日期',
  'production.shipments.wms_inspect_detail.columns.updated_at': '更新日期',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.label': '检验信息',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.sn': '序列号',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.status': '检验结果',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.summary': '检验总结',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.inspector': '检验人',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.inspect_time': '检验时间',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.pictures': '检验图片',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.order_number': '订单号',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.order_number_type': '订单号类型',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.material_number': '物料编号',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.material_name': '物料名称',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.warehouse': '仓库',
  'production.shipments.wms_inspect_detail.form_items.inspection_info.out_count': '出货数量',
  'production.shipments.wms_inspect_detail.form_items.inspection_data.label': '检验数据',
  'production.shipments.wms_inspect_detail.form_items.inspection_data.check_count': '检验数量',
  'production.shipments.wms_inspect_detail.form_items.inspection_data.bad_count': '不良数量',
  'production.shipments.wms_inspect_detail.form_items.inspection_data.status': '状态',
  'production.shipments.wms_inspect_detail.form_items.inspection_data.remarks': '备注',
  'production.shipments.inspect_standard.title': '出货检验规范',
  'production.shipments.output_inspection_order_detail_status_enum.pending': '待检',
  'production.shipments.output_inspection_order_status_enum.pending': '未完成',
  'production.shipments.title': '出货',
  'production.title': '生产质量管理',
  'production.types.iqc_inspect.iqc_inspect_bill_cancel_status_options.cancel': '作废',
  'production.types.iqc_inspect.iqc_inspect_bill_cancel_status_options.normal': '正常',
  'production.types.iqc_inspect.iqc_inspect_bill_status_options.finished': '已完成',
  'production.types.iqc_inspect.iqc_inspect_bill_status_options.processing': '检验中',
  'production.types.iqc_inspect.iqc_inspect_bill_status_options.stand_by': '待分配',
  'production.types.iqc_inspect.iqc_inspect_bill_status_options.wait': '待检验',
  'production.types.iqc_inspect.material_phase_options.trial': '试产阶段',
  'production.types.iqc_inspect.material_phase_options.production': '量产阶段',
  'production.types.iqc_inspect.material_phase_options.eol': 'EOL阶段',
  'production.types.iqc_inspect.material_phase_options.abandoned': '废弃阶段',
  'production.types.iqc_inspect.iqc_inspect_bill_type_options.other': '其他',
  'production.types.iqc_inspect.iqc_inspect_bill_type_options.production': '量产单据',
  'production.types.iqc_inspect.iqc_inspect_bill_type_options.trial': '试产单据',
  'production.types.iqc_inspect.iqc_inspect_is_rush_options.not_rush': '否',
  'production.types.iqc_inspect.iqc_inspect_is_rush_options.rush': '加急单',
  'production.types.iqc_inspect.iqc_inspect_is_special_options.not_special': '否',
  'production.types.iqc_inspect.iqc_inspect_is_special_options.special': '特采',
  'production.types.iqc_inspect.iqc_inspect_policy_use_options.accept': '接收',
  'production.types.iqc_inspect.iqc_inspect_policy_use_options.reject': '拒收',
  'production.types.iqc_inspect.iqc_inspect_policy_use_options.conditional_accept': '让步接收',
  'production.types.iqc_inspect.iqc_inspect_receive_has_sample_options.false': '否',
  'production.types.iqc_inspect.iqc_inspect_receive_has_sample_options.true': '是',
  'production.types.iqc_inspect.iqc_inspect_receive_is_push_options.false': '否',
  'production.types.iqc_inspect.iqc_inspect_receive_is_push_options.true': '是',
  'production.types.iqc_inspect.iqc_inspect_result_options.fail': '不合格',
  'production.types.iqc_inspect.iqc_inspect_result_options.pass': '合格',
  'production.types.iqc_inspect.iqc_inspect_rework_methods_options.on_line': '上线挑选',
  'production.types.iqc_inspect.iqc_inspect_rework_methods_options.on_site': '现场返工',
  'production.types.iqc_inspect.iqc_inspect_rework_methods_options.special': '特采',
  'production.types.iqc_inspect.iqc_receive_cancel_status_options.cancel': '作废',
  'production.types.iqc_inspect.iqc_receive_cancel_status_options.normal': '正常',
  'production.types.iqc_inspect.iqc_receive_is_rush_options.not_rush': '否',
  'production.types.iqc_inspect.iqc_receive_is_rush_options.rush': '是',
  'production.types.iqc_inspect.iqc_receive_row_status_options.close': '已关闭',
  'production.types.iqc_inspect.iqc_receive_row_status_options.normal': '正常',
  'production.types.iqc_inspect.iqc_receive_row_status_options.terminate': '已终止',
  'production.types.iqc_inspect.iqc_receive_status_options.audit': '审核中',
  'production.types.iqc_inspect.iqc_receive_status_options.create': '新创建',
  'production.types.iqc_inspect.iqc_receive_status_options.finish': '已审核',
  'production.types.iqc_inspect.iqc_receive_status_options.re_audit': '重新审核',
  'production.types.iqc_inspect.iqc_receive_status_options.suspend': '暂存',
  'production.types.iqc_inspect_spec.material_inspect_specification_is_common_options.no': '否',
  'production.types.iqc_inspect_spec.material_inspect_specification_is_common_options.yes': '是',
  'production.types.iqc_inspect_spec.material_inspect_specification_status_options.publish': '已发布',
  'production.types.iqc_inspect_spec.material_inspect_specification_status_options.un_publish': '未发布',
  'production.types.iqc_sample_scheme.inspect_level_enum.level1': '特殊（S-1）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level2': '特殊（S-2）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level3': '特殊（S-3）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level4': '特殊（S-4）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level5': '一般（I）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level6': '一般（II）',
  'production.types.iqc_sample_scheme.inspect_level_enum.level7': '一般（III）',
  'production.types.iqc_sample_scheme.sample_type_enum.all': '全检',
  'production.types.iqc_sample_scheme.sample_type_enum.self_defined': '自定义抽样',
  'production.types.iqc_sample_scheme.sample_type_enum.aql': 'AQL抽样',
  'production.types.iqc_sample_scheme.sample_type_enum.percent': '百分比抽样',
  'production.types.iqc_sample_scheme.sample_type_enum.fixed': '固定抽样',
  'production.types.iqc_sample_scheme.strict_level_enum.level1': '正常检验',
  'production.types.iqc_sample_scheme.strict_level_enum.level2': '加严检验',
  'production.types.iqc_sample_scheme.strict_level_enum.level3': '放宽检验',
  'production.types.material.iqc_inspect_status_enum.failed': '不合格',
  'production.types.material.iqc_inspect_status_enum.pass': '合格',
  'production.types.material.iqc_inspect_status_enum.special': '特采',
  'production.types.material.iqc_is_key_enum.no': '否',
  'production.types.material.iqc_is_key_enum.yes': '是',
  'production.types.material.issue_priority_enum.high': '高',
  'production.types.material.issue_priority_enum.low': '低',
  'production.types.material.issue_priority_enum.medium': '中',
  'production.types.material.issue_status_enum.closed': '关闭',
  'production.types.material.issue_status_enum.created': '新建',
  'production.types.material.issue_status_enum.hangup': '挂起',
  'production.types.material.issue_status_enum.processing': '处理中',
  'production.types.material.issue_status_enum.solved': '已解决',
  'production.types.material.material_issue_class_enum.appearance': '外观',
  'production.types.material.material_issue_class_enum.environmental': '环保',
  'production.types.material.material_issue_class_enum.function': '功能',
  'production.types.material.material_issue_class_enum.mixed': '混料',
  'production.types.material.material_issue_class_enum.other': '其他',
  'production.types.material.material_issue_class_enum.reliability': '可靠性',
  'production.types.material.material_issue_class_enum.safety': '安规',
  'production.types.material.material_issue_class_enum.size': '尺寸',
  'production.types.material.material_issue_emergency_response_enum.direct_pass': '直接放行',
  'production.types.material.material_issue_emergency_response_enum.line_select': '产线挑选',
  'production.types.material.material_issue_emergency_response_enum.return': '退货',
  'production.types.material.material_issue_emergency_response_enum.special_sampling': '特采',
  'production.types.material.material_issue_emergency_response_enum.supplier_to_iqc': '供应商到IQC挑选',
  'production.types.material.material_sample_status_enum.sign': '已签样',
  'production.types.material.material_sample_status_enum.un_sign': '未签样',
  'production.types.material.material_sample_type_enum.official': '正式样',
  'production.types.material.material_sample_type_enum.temporary': '临时样',
  'production.types.material.material_sample_status_options.un_sign': '未签样',
  'production.types.material.material_sample_status_options.test': '试产样',
  'production.types.material.material_sample_status_options.official': '正式样',
  'production.types.material.material_sample_status_options.no_sign': '无需签样',
  'production.types.material.material_type_enum.auxiliary': '包材辅料',
  'production.types.material.material_type_enum.electronic': '电子件',
  'production.types.material.material_type_enum.structure': '结构件',
  'production.types.material.sample_maintain_enum.ack': '样品承认书',
  'production.types.material.sample_maintain_enum.drawing': '设计稿/图纸',
  'production.types.material.sample_maintain_enum.epi': '环保协议书',
  'production.types.material.sample_maintain_enum.physical': '实物',
  'project.dashboard.title': '看板',
  'project.dev.auto_test.title': '自动化测试',
  'project.dev.demand_management.title': '需求管理',
  'project.dev.product_demand_ai.title': '产品需求AI',
  'project.dev.product_demand_list_detail.title': '产品需求列表详情',
  'project.dev.submit_test.title': '项目提测',
  'project.dev.test_plan.title': '测试计划',
  'project.dev.test_plan_detail.title': '测试计划详情',
  'project.dev.test_plan_report.title': '测试计划报告',
  'project.dev.test_programme.title': '测试方案',
  'project.dev.test_record_detail.title': '提测记录详情',
  'project.dev.test_report.title': '测试报告',
  'project.dev.test_report_detail.title': '测试报告详情',
  'project.dev.testcase.title': '测试用例',
  'project.dev.title': '研发测试',
  'project.inspect.base_layout.base_checklist.exec_spec.result': '结果',
  'project.inspect.base_layout.base_checklist.form_item.attachment': '图示',
  'project.inspect.base_layout.base_checklist.form_item.grade': '等级面',
  'project.inspect.base_layout.base_checklist.form_item.method': '检验方法',
  'project.inspect.base_layout.base_checklist.form_item.name': '测试点',
  'project.inspect.base_layout.base_checklist.form_item.priority': '优先级',
  'project.inspect.base_layout.base_checklist.form_item.steps': '步骤',
  'project.inspect.base_layout.base_checklist.form_item.test_conditions': '测试条件',
  'project.inspect.base_layout.base_checklist.form_item.test_spec': '合格标准(测试标准)',
  'project.inspect.base_layout.base_checklist.form_item.tool': '检验工具',
  'project.inspect.base_layout.base_checklist.render_check_once.button': '批量执行',
  'project.inspect.base_layout.base_checklist.render_check_once.reset': '重置',
  'project.inspect.base_layout.base_checklist.render_check_once.title': '批量更新结果',
  'project.inspect.base_layout.create.button': '新建',
  'project.inspect.base_layout.create.hide_button': '取消',
  'project.inspect.base_layout.create.submit.button': '创建',
  'project.inspect.base_layout.create.submit.error_message': '表单检验不通过：{err}',
  'project.inspect.base_layout.create.submit.no_check_record_message': '检验规范未创建，请先前往创建检验规范',
  'project.inspect.base_layout.create.submit.procedure.inspection': '巡检',
  'project.inspect.base_layout.create.submit.procedure.machine': '整机',
  'project.inspect.base_layout.create.submit.procedure.package': '包装',
  'project.inspect.base_layout.create.submit.procedure_not_match_message': '无法判别检验单类型，请手动创建问题单',
  'project.inspect.base_layout.create.submit.success_message': '检验单创建成功',
  'project.inspect.base_layout.create.submit.un_match_message': '检验结果与检验规范中的测试点结果不符',
  'project.inspect.base_layout.create.title': '创建{title}',
  'project.inspect.base_layout.delete.button': '删除',
  'project.inspect.base_layout.delete.cancel_text': '取消',
  'project.inspect.base_layout.delete.error_message': '删除失败',
  'project.inspect.base_layout.delete.ok_text': '确认',
  'project.inspect.base_layout.delete.success_message': '删除成功',
  'project.inspect.base_layout.delete.title': '是否确认删除，删除后将不可恢复',
  'project.inspect.base_layout.edit.button': '编辑',
  'project.inspect.base_layout.export_button': '导出',
  'project.inspect.inspection_checklist.columns.bad_attribution': '异常归属',
  'project.inspect.inspection_checklist.columns.bad_count': '不良数',
  'project.inspect.inspection_checklist.columns.bad_rate': '不良率',
  'project.inspect.inspection_checklist.columns.check_count': '检验数量',
  'project.inspect.inspection_checklist.columns.check_date': '检验时间',
  'project.inspect.inspection_checklist.columns.check_pictures': '检验图片',
  'project.inspect.inspection_checklist.columns.create_by': '创建者',
  'project.inspect.inspection_checklist.columns.created_at': '创建日期',
  'project.inspect.inspection_checklist.columns.id': 'ID',
  'project.inspect.inspection_checklist.columns.is_first_piece': '是否首件',
  'project.inspect.inspection_checklist.columns.issue_content': '问题描述',
  'project.inspect.inspection_checklist.columns.procedure_class': '测试分类',
  'project.inspect.inspection_checklist.columns.procedure_name': '检验工序',
  'project.inspect.inspection_checklist.columns.status': '检验结果',
  'project.inspect.inspection_checklist.columns.sys_project_id': '产品项目',
  'project.inspect.inspection_checklist.columns.update_by': '更新者',
  'project.inspect.inspection_checklist.columns.updated_at': '更新日期',
  'project.inspect.inspection_checklist.export.filename': '巡检检验单-{date}.xlsx',
  'project.inspect.inspection_checklist.export.success_message': '{filename} 导出成功, 请在下载文件中查看',
  'project.inspect.inspection_checklist.form.form_items.basic_info.check_record': '检验规范',
  'project.inspect.inspection_checklist.form.form_items.basic_info.is_first_piece': '是否首件',
  'project.inspect.inspection_checklist.form.form_items.basic_info.label': '基本信息',
  'project.inspect.inspection_checklist.form.form_items.basic_info.org_id.label': '所属组织',
  'project.inspect.inspection_checklist.form.form_items.basic_info.org_id.options.domestic': '国内',
  'project.inspect.inspection_checklist.form.form_items.basic_info.org_id.options.thailand': '泰国工厂',
  'project.inspect.inspection_checklist.form.form_items.basic_info.procedure_class_id': '测试分类',
  'project.inspect.inspection_checklist.form.form_items.basic_info.procedure_name': '检验工序',
  'project.inspect.inspection_checklist.form.form_items.basic_info.remark': '备注',
  'project.inspect.inspection_checklist.form.form_items.basic_info.series_id': '产品系列',
  'project.inspect.inspection_checklist.form.form_items.basic_info.sys_project_id': '产品项目',
  'project.inspect.inspection_checklist.form.form_items.error_message': '请求项目列表失败: {err}',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.bad_count': '不良数',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.check_count': '抽检数',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.check_date': '检验时间',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.check_pictures': '检验图片',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.label': '检验数据',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.status': '检验结果',
  'project.inspect.inspection_checklist.form.form_items.inspection_data.total': '投入数',
  'project.inspect.inspection_checklist.title': '巡检检验单',
  'project.inspect.package.columns.bad_attribution': '异常归属',
  'project.inspect.package.columns.bad_count': '不良数',
  'project.inspect.package.columns.bad_rate': '不良率',
  'project.inspect.package.columns.check_content': '检验内容',
  'project.inspect.package.columns.check_count': '检验数量',
  'project.inspect.package.columns.check_date': '检验时间',
  'project.inspect.package.columns.check_pictures': '检验图片',
  'project.inspect.package.columns.create_by': '创建者',
  'project.inspect.package.columns.created_at': '创建日期',
  'project.inspect.package.columns.id': 'ID',
  'project.inspect.package.columns.is_first_piece': '是否首件',
  'project.inspect.package.columns.issue_content': '问题描述',
  'project.inspect.package.columns.order_count': '订单数量',
  'project.inspect.package.columns.order_number': '订单号',
  'project.inspect.package.columns.sku': '产品SKU',
  'project.inspect.package.columns.sn': '外箱SN号',
  'project.inspect.package.columns.status': '检验结果',
  'project.inspect.package.columns.sys_project_id': '产品项目',
  'project.inspect.package.columns.update_by': '更新者',
  'project.inspect.package.columns.updated_at': '更新日期',
  'project.inspect.package.columns.whole_machine_code': '整机编号',
  'project.inspect.package.create_package_table.base_columns.action': '操作',
  'project.inspect.package.create_package_table.base_columns.grade': '等级面',
  'project.inspect.package.create_package_table.base_columns.method': '检验方法',
  'project.inspect.package.create_package_table.base_columns.name': '测试点',
  'project.inspect.package.create_package_table.base_columns.priority': '优先级',
  'project.inspect.package.create_package_table.base_columns.steps': '步骤',
  'project.inspect.package.create_package_table.base_columns.test_conditions': '测试条件',
  'project.inspect.package.create_package_table.base_columns.test_spec': '合格标准(测试标准)',
  'project.inspect.package.create_package_table.base_columns.tool': '检验工具',
  'project.inspect.package.create_package_table.priority_color_map.high': '高',
  'project.inspect.package.create_package_table.priority_color_map.low': '低',
  'project.inspect.package.create_package_table.priority_color_map.medium': '中',
  'project.inspect.package.export.filename': '包装检验单-{date}.xlsx',
  'project.inspect.package.export.success_message': '{filename} 导出成功, 请在下载文件中查看',
  'project.inspect.package.form.form_items.basic_info.accreditation_picture': '评审图片',
  'project.inspect.package.form.form_items.basic_info.accreditation_requirements': '评审需求',
  'project.inspect.package.form.form_items.basic_info.is_first_piece': '是否首件',
  'project.inspect.package.form.form_items.basic_info.label': '基本信息',
  'project.inspect.package.form.form_items.basic_info.order_count': '产品订单数量',
  'project.inspect.package.form.form_items.basic_info.order_number': '订单号',
  'project.inspect.package.form.form_items.basic_info.org_id.label': '所属组织',
  'project.inspect.package.form.form_items.basic_info.org_id.options.domestic': '国内',
  'project.inspect.package.form.form_items.basic_info.org_id.options.thailand': '泰国工厂',
  'project.inspect.package.form.form_items.basic_info.remark': '备注',
  'project.inspect.package.form.form_items.basic_info.series_id': '产品系列',
  'project.inspect.package.form.form_items.basic_info.sku': '产品SKU',
  'project.inspect.package.form.form_items.basic_info.sku_name': '产品名称',
  'project.inspect.package.form.form_items.basic_info.sn': '外箱SN',
  'project.inspect.package.form.form_items.basic_info.sys_project_id': '产品项目',
  'project.inspect.package.form.form_items.basic_info.whole_machine_code.error_message': '该整机编号已存在，请重新输入',
  'project.inspect.package.form.form_items.basic_info.whole_machine_code.label': '整机编号',
  'project.inspect.package.form.form_items.inspection_data.bad_count': '不良数',
  'project.inspect.package.form.form_items.inspection_data.check_count': '检验数量',
  'project.inspect.package.form.form_items.inspection_data.check_date': '检验时间',
  'project.inspect.package.form.form_items.inspection_data.check_pictures': '检验图片',
  'project.inspect.package.form.form_items.inspection_data.check_record': '检验规范',
  'project.inspect.package.form.form_items.inspection_data.label': '检验数据',
  'project.inspect.package.form.form_items.inspection_data.status': '检验结果',
  'project.inspect.package.form.render_select_check_once.button': '请先选择检验规范',
  'project.inspect.package.form.render_select_check_once.title': '选择检验规范',
  'project.inspect.package.title': '包装检验单',
  'project.inspect.package_auto_inspect.columns.annotated_image': '标注图像',
  'project.inspect.package_auto_inspect.columns.auto_inspect_result': 'AI检验结果',
  'project.inspect.package_auto_inspect.columns.create_by': '创建者',
  'project.inspect.package_auto_inspect.columns.created_at': '创建日期',
  'project.inspect.package_auto_inspect.columns.id': 'ID',
  'project.inspect.package_auto_inspect.columns.inspect_model_version_id': '模型版本',
  'project.inspect.package_auto_inspect.columns.inspect_result': '检验结果',
  'project.inspect.package_auto_inspect.columns.inspect_result_image': '检验图像',
  'project.inspect.package_auto_inspect.columns.product_sku': '产品SKU',
  'project.inspect.package_auto_inspect.columns.sn': '外箱SN号',
  'project.inspect.package_auto_inspect.columns.sys_project_id': '产品项目',
  'project.inspect.package_auto_inspect.create_button': '导出数据',
  'project.inspect.package_auto_inspect.export.filename': '包装自动检验单-{date}.csv',
  'project.inspect.package_auto_inspect.export.success_message': '成功导出 {filename}',
  'project.inspect.package_auto_inspect.title': '包装自动检验单',
  'project.inspect.title': '质检',
  'project.inspect.whole_machine_checklist.columns.bad_attribution': '异常归属',
  'project.inspect.whole_machine_checklist.columns.check_date': '检验时间',
  'project.inspect.whole_machine_checklist.columns.check_pictures': '检验图片',
  'project.inspect.whole_machine_checklist.columns.create_by': '创建者',
  'project.inspect.whole_machine_checklist.columns.create_by_pt': '产测检验员',
  'project.inspect.whole_machine_checklist.columns.pt_user_role': '产测用户角色',
  'project.inspect.whole_machine_checklist.columns.created_at': '创建日期',
  'project.inspect.whole_machine_checklist.columns.id': 'ID',
  'project.inspect.whole_machine_checklist.columns.is_repair': '是否返修',
  'project.inspect.whole_machine_checklist.columns.issueId': '问题单',
  'project.inspect.whole_machine_checklist.columns.issue_content': '问题描述',
  'project.inspect.whole_machine_checklist.columns.machine_class': '测试类型',
  'project.inspect.whole_machine_checklist.columns.machine_series_number': '机台序列号',
  'project.inspect.whole_machine_checklist.columns.status': '检验结果',
  'project.inspect.whole_machine_checklist.columns.sys_project_id': '产品项目',
  'project.inspect.whole_machine_checklist.columns.update_by': '更新者',
  'project.inspect.whole_machine_checklist.columns.updated_at': '更新日期',
  'project.inspect.whole_machine_checklist.columns.whole_machine_code': '整机编号',
  'project.inspect.whole_machine_checklist.export.filename': '整机检验单-{date}.xlsx',
  'project.inspect.whole_machine_checklist.export.success_message': '{filename} 导出成功, 请在下载文件中查看',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.check_date': '检验时间',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.check_pictures': '检验图片',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.is_repair': '是否返修',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.label': '历史检验记录',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.machine_class': '测试分类',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.remark': '备注',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.history.status': '检验结果',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.is_repair.label': '是否需要返修',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.is_repair.tooltip':
    '是否需要返修：选择“是，重新检验”，则表示需要返修，且重新开始流程；选择“是，继续检验”，则表示需要返修，且从当前流程继续测试；选择否，则表示不需要返修。',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.label': '基础数据',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.laser_engraving_code': '镭雕码',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_class_id.error_message':
    '请求项目列表失败: {err}',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_class_id.label': '测试分类',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_class_id.no_check_record_message':
    '请先创建整机检验规范',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_series_number.error_message_length':
    '机台序列号长度不正确，请重新输入',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_series_number.error_message_factory':
    '机台序列号不属于当前工厂，请切换至其他工厂',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_series_number.error_message':
    '机台序列号不属于当前项目，请切换至其他项目',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.machine_series_number.label': '机台序列号',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.org_id.label': '所属组织',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.org_id.options.domestic': '国内',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.org_id.options.thailand': '泰国工厂',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.pre_whole_machine_code.label': '变更前整机编号',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.pre_whole_machine_code.tooltip':
    '若整机编号因主板维修/激光头维修更换而发生改变，需填写变更前整机编号以追溯历史记录。',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.series_id': '产品系列',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.sys_project_id': '产品项目',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.whole_machine_code.error_message':
    '机台序列号不属于当前项目，请切换至其他项目',
  'project.inspect.whole_machine_checklist.form.form_items.basic_info.whole_machine_code.label': '整机编号',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.check_date': '检验时间',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.test_time_span': '测试耗时',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.check_pictures': '检验图片',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.check_record': '检验规范',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.label': '检验数据',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.remark': '备注',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.content': '产测记录',
  'project.inspect.whole_machine_checklist.form.form_items.inspection_data.status': '检验结果',
  'project.inspect.whole_machine_checklist.title': '整机检验单',
  'project.inspect_standard.finish.title': '包装检验规范',
  'project.inspect_standard.machine.title': '整机检验规范',
  'project.inspect_standard.process.title': '巡检检验规范',
  'project.inspect_standard.qcdrawing.title': 'QC工程图',
  'project.inspect_standard.title': '质检标准',
  'project.issue.detail.title': '研发问题详情',
  'project.issue.list.title': '研发问题',
  'project.issue.production_material.title': '来料问题',
  'project.issue.production_process.title': '制程问题',
  'project.issue.trial_production.title': '试产问题',
  'project.issue.risk.title': '风险',
  'project.issue.title': '问题列表',
  'project.rr.repair_list.title': '维修单',
  'project.rr.rework_list.title': '返工单',
  'project.rr.title': '返工维修',
  'project.setting.bom.title': 'BOM',
  'project.setting.components.title': '模块管理',
  'project.setting.production.title': '生产设置',
  'project.setting.system.title': '项目设置',
  'project.setting.title': '设置',
  'project.setting.tr_node_config.title': '评审设置',
  'project.setting.version.title': '版本管理',
  'project.title': '项目/产品空间',
  'project.tr.old.title': '转阶段评审',
  'project.tr.standards_controlled.title': '评审标准受控',
  'project.tr.standards_module.title': '评审标准模块库',
  'project.tr.standards_repository.title': '评审标准库',
  'project.tr.title': '转阶段评审',
  'project.tr_detail.title': '评审记录详情',
  'site_route_item.development': '研发质量',
  'site_route_item.development.accident_review': '事故复盘',
  'site_route_item.development.dashboard': '质量看板',
  'site_route_item.development.client_performance_report': '性能报告',
  'site_route_item.development.client_performance_case-detail': '用例详情',
  'site_route_item.development.ui_automation_report': 'UI自动化报告',
  'site_route_item.development.demand_list': '需求列表',
  'site_route_item.development.report': '质量报告',
  'site_route_item.development.test_record_list': '提测记录',
  'site_route_item.development.test_report_list': '测试报告',
  'site_route_item.development.version': '版本对比',
  'site_route_item.issue': '缺陷管理',
  'site_route_item.issue.dashboard': '仪表盘',
  'site_route_item.issue.detail': '问题详情',
  'site_route_item.issue.feishu_work_item_setting': '飞书项目推送设置',
  'site_route_item.issue.list': '问题列表',
  'site_route_item.issue.setting': '设置',
  'site_route_item.issue.setting.field_config': '字段配置',
  'site_route_item.issue.setting.template_config': '问题模板配置',
  'site_route_item.issue.setting.scheme_config': '模板方案配置',
  'site_route_item.issue.setting.project_config': '项目配置',
  'site_route_item.issue.setting.dept_responsible_mapping': '部门-责任方映射',
  'site_route_item.issue.setting.dept_rollup_rule': '部门归并规则',
  'workplace.convenient_entry.apps.admin.role_management.title': '角色管理',
  'workplace.convenient_entry.apps.admin.user_management.title': '用户管理',
  'workplace.convenient_entry.apps.default.material_issues.title': '来料问题库',
  'workplace.convenient_entry.apps.default.material_quality.title': '来料质量',
  'workplace.convenient_entry.apps.default.process_issues.title': '制程问题库',
  'workplace.convenient_entry.apps.default.process_quality.title': '制程质量',
  'workplace.convenient_entry.apps.default.rd_issues.title': '研发问题库',
  'workplace.convenient_entry.apps.default.supplier_quality.title': '供应商质量',
  'workplace.convenient_entry.apps.developer.my_issue.title': '我的问题',
  'workplace.convenient_entry.apps.dqe.material_quality.title': '来料质量',
  'workplace.convenient_entry.apps.dqe.process_quality.title': '制程质量',
  'workplace.convenient_entry.apps.dqe.supplier_quality.title': '供应商质量',
  'workplace.convenient_entry.apps.fqc.inspect_machine.title': '整机测试',
  'workplace.convenient_entry.apps.fqc.inspect_package.title': '包装检验',
  'workplace.convenient_entry.apps.fqc.process_issue.title': '制程问题',
  'workplace.convenient_entry.apps.ipqc.inspection_check.title': '巡检检验',
  'workplace.convenient_entry.apps.ipqc.process_issue.title': '制程问题',
  'workplace.convenient_entry.apps.oqc.inspect_detail.title': '出货明细',
  'workplace.convenient_entry.apps.oqc.inspect_order.title': '出货检验',
  'workplace.convenient_entry.apps.oqc.process_issue.title': '制程问题',
  'workplace.convenient_entry.apps.pqe.material_quality.title': '来料质量',
  'workplace.convenient_entry.apps.pqe.process_quality.title': '制程质量',
  'workplace.convenient_entry.apps.pqe.supplier_quality.title': '供应商质量',
  'workplace.convenient_entry.apps.product.issue_dashboard.title': '问题看板',
  'workplace.convenient_entry.apps.product.issue_list.title': '问题列表',
  'workplace.convenient_entry.apps.product.my_issue.title': '我的问题',
  'workplace.convenient_entry.apps.tester.issue_list.title': '问题列表',
  'workplace.convenient_entry.apps.tester.my_issue.title': '我的问题',
  'workplace.convenient_entry.title': '便捷入口',
  'workplace.greeting.greeting1': '凌晨好',
  'workplace.greeting.greeting2': '早上好',
  'workplace.greeting.greeting3': '上午好',
  'workplace.greeting.greeting4': '中午好',
  'workplace.greeting.greeting5': '下午好',
  'workplace.greeting.greeting6': '晚上好',
  'workplace.greeting.not_only': '，你不仅仅是一个',
  'workplace.platform_app.apps.after_sale.after_sales_analysis.title': '售后分析',
  'workplace.platform_app.apps.after_sale.after_sales_data.title': '售后数据',
  'workplace.platform_app.apps.after_sale.feedback.title': '反馈管理',
  'workplace.platform_app.apps.after_sale.title': '售后反馈管理',
  'workplace.platform_app.title': '平台应用',
  'workplace.project.all_projects': '所有项目/产品',
  'workplace.project.empty': '您暂未加入任何项目/产品',
  'workplace.project.enter': '进入',
  'workplace.project.my_projects': '我的项目/产品',
  'workplace.right_message.all_issues': '所有问题',
  'workplace.right_message.all_pending_assign': '所有待分配',
  'workplace.right_message.all_pending_inspection': '所有待检验',
  'workplace.right_message.all_pending_inspection_finish': '所有已完成',
  'workplace.right_message.all_pending_inspection_no_create_issue': '未创建问题单',
  'workplace.right_message.all_pending_inspection_process': '所有检验中',
  'workplace.right_message.assigning_bill': '待分配单据',
  'workplace.right_message.my_iqc_bill': '我的待检单据',
  'workplace.right_message.pending_test_versions': '待提测版本',
  'workplace.right_message.total_receive_bill': '收料单总数',
  'workplace.right_message.un_push_bill': '未下推单据',
  'workplace.right_message.unclosed_issues': '未关闭问题',
  'workplace.statistics.other.allProjectCount': '项目总数',
  'workplace.statistics.other.finishedProjectCount': '已完成项目数',
  'workplace.statistics.other.maintainingProjectCount': '维护中项目数',
  'workplace.statistics.other.onGoingProjectCount': '进行中项目数',
  'workplace.statistics.project.allProjectCount': '项目总数',
  'workplace.statistics.project.myProjectCount': '我的项目数',
  'workplace.tab_list.assigning': '待分配',
  'workplace.tab_list.demand_task': '需求任务',
  'workplace.tab_list.inspect_order': '新增检验单',
  'workplace.tab_list.ort_test_task': 'ORT测试任务',
  'workplace.tab_list.pending_inspection': '待检验',
  'workplace.tab_list.pending_inspection_finish': '已完成',
  'workplace.tab_list.pending_inspection_process': '检验中',
  'workplace.tab_list.problem_task': '待解决问题',
  'workplace.tab_list.receive_bill': '新增收料单',
  'workplace.tab_list.received_bill': '已下推收料单',
  'workplace.tab_list.rush_order': '加急检验单',
  'workplace.tab_list.suspended_issues': '挂起问题',
  'workplace.tab_list.test_task': '测试任务',
  'workplace.tab_list.verify_issues': '待验证问题',
  'workplace.title': '工作台',
  'workplace.todo_list.title': '待办',

  'workplace.my_dashboard.title': '我的看板',
  'workplace.my_dashboard.customer_dashboard.title': '自定义看板',
  'workplace.my_dashboard.dashboard_manage.title': '看板管理',

  // 精准测试（新）模块翻译
  'precision.new.title': '精准测试（新）',
  'precision.new.feishu.documents': '飞书文档',
  'precision.new.document.analyze': '文档分析',
  'precision.new.knowledge.graph': '知识图谱',
  'precision.new.coverage.report': '覆盖率报告',
  'precision.new.ai.analyzing': 'AI分析中',
  'precision.new.case.recommend': '用例推荐（AI）',
  'precision.new.ai.analysis': 'AI智能分析',
  'precision.new.ai.report': 'AI分析报告',
  'precision.new.code.binding': '代码绑定',
  'precision.new.impact.analysis': '影响分析',
  'pytest.projects.title': '接口服务',
  'pytest.project.detail': '项目详情',
  'pytest.project.editor': 'YAML编辑器',
  'pytest.project.cases': '用例管理',
  'pytest.project.execute': '测试执行',
  'pytest.project.reports': '测试报告',
  'pytest.report.detail': '报告详情',
};
